var nsModuleExport = function(root,name,prototype)
	{
		if(typeof exports === 'object' && typeof module === 'object')
		{
			module.exports[name] = prototype;
		}
		else if (typeof define === "function" && define.amd)
		{
			define(name,[], function () {return prototype;});
		}
		else if(typeof exports === 'object')
		{
			exports[name] = prototype;
		}
		else
		{
			root[name] = prototype;
		}
	};var nsIsWeb = function(root)
	{
		if(typeof exports === 'object' && typeof module === 'object')
		{
			return false;
		}
		else if (typeof define === "function" && define.amd)
		{
			return false;
		}
		else if(typeof exports === 'object')
		{
			return false;
		}
		else
		{
			return true;
		}
	};if(!nsIsWeb())
		{
var nsutilRef = require('./nsUtil.min.js');
var NSUtil = nsutilRef.NSUtil;
var nscontainerbaseRef = require('./nsContainerBase.min.js');
var nsExtendPrototype = nscontainerbaseRef.nsExtendPrototype;
var NSContainerBase = nscontainerbaseRef.NSContainerBase;
var svgRef = require('./nsSVG.min.js');
var NSSvg = svgRef.NSSvg;
var NSSvgShapes = svgRef.NSSvgShapes;
var plugginsRef = require('./nsPluggins.min.js');
var nsTextEditor = plugginsRef.nsTextEditor;
var nsTextAreaEditor = plugginsRef.nsTextAreaEditor;
var NSCellSelection = plugginsRef.NSCellSelection;
var NSTableCellNavigator = plugginsRef.NSTableCellNavigator;
var dateutilRef = require('./nsDateUtil.min.js');
var NSDateUtil = dateutilRef.NSDateUtil;
var gridRef = require('./nsGrid.min.js');
var NSGrid = gridRef.NSGrid;

		}
var NSList = (function()
{
	function NSList(component,setting) 
	{
		//this.base.call(this);
		this.ITEM_SELECTED = "itemSelected";
		this.ITEM_UNSELECTED = "itemUnselected";
		this.ITEM_NAVIGATED = "itemNavigated";
		this.NAVIGATION_UP = "up";
		this.NAVIGATION_DOWN = "down";
		this.ITEM_DROPPING = "itemDropping";
		this.ITEM_DROPPED = "itemDropped";
		this.DRAG_STARTED = "dragStarted";
		this.DRAGGING = "dragging";
		this.DRAG_END = "dragEnd";
		
		this.__setting = setting;
		this.__dataSource = null;
		this.__labelField = "label";
		this.__itemRenderer = null;
		this.__templateID = null;
		this.__setData = null;
		this.__labelFunction = null;
		this.__enableHierarchical = false;
		this.__enableMouseHover = false;
		this.__enableMouseHoverAnimation = false;
		this.__disableHoverField = null;
		this.__disableHoverFunction = null;
		this.__enableKeyboardNavigation = false;
		this.__enableMultipleSelection = false;
		this.__enableCustomScrollBar = false;
		this.__enableVirtualScroll = false;
		this.__isDraggable = true;
		this.__isDroppable = true;
		this.__enableDragByHandle = false;
		this.__dragHandlerClass = null;
		this.__enableDragAfterHold = false;
		this.__holdTime = 500;
		this.__enableCloneMode = false;
		this.__rowHeight = -1;
		this.__noDataMessage = "No matching records found";
		this.__enableContextMenu = false;
		this.__enableVariableRowHeight = false;
		this.__contextMenuProvider = null;
		this.__contextMenuSetting = null;
		this.__enableTruncateToFit = false;
		this.__toolTipField = null;
		this.__enableToolTipForTruncateText = false;
		this.__toolTipRenderer = null;
		
		this.__arrWrapper = null;
		this.__arrInternalSource = null;
		this.__arrFlatHierarchicalSource = [];
		
		this.__divOuterContainer = null;
		this.__divParentContainer = null;
		this.__listContainer = null;
		this.__scroller = null;
		this.__scrollerSetting = {};
		this.__customScrollBarSetting = {};
		this.__customScrollBarTooltip = null;
		
		this.__template = null;
		this.__currentIndex = -1;
		this.__selectedIndex = -1;
		this.__navigationIndex = -1;
		this.__selectedItem = null;
		this.__selectedItems = [];	
		this.__selectedIndexes = [];
		this.__lastNavigationDirection = null;
		this.__orignalItemKey = [];
		//for keyboard navigation
		this.__pageSize = 0;
		this.__scrollTarget = null;
		this.__startArrayElement = -1;
		this.__listItemHeight = 0;
		//for Virtual Scroll
		this.__virtualScrollSetting = {};
		this.__nsVirtualScroll = null; 
		this.__virtualRowHeight = 0;
		
		this.__childField = "children";
		this.__CLASS_GROUP_CELL = "nsListGroupCell";
		this.__CLASS_CELL_CHILD = "nsListCellChild";
		
		//removing this.getID() as prefix as move functionality from one list to another would have different fields.
		this.__fieldPrefix = "ns_field";
		this.__fieldIndex =  this.__fieldPrefix + "_item_index";
		this.__fieldVisibleIndex = this.__fieldPrefix + "_item_visible_index";
		this.__fieldItem = this.__fieldPrefix + "_item";
		this.__fieldDisableHover = this.__fieldPrefix + "_disableHover";
		this.__fieldSelected = this.__fieldPrefix + "_selected";
		this.__fieldHover = this.__fieldPrefix + "_hover";
		
		this.__fieldItemLevel = this.__fieldPrefix + "_item_level";
		this.__fieldItemVisible = this.__fieldPrefix + "_item_visible";
		this.__fieldParentIndex = this.__fieldPrefix + "_parent_index";
		this.__fieldHasChild = this.__fieldPrefix + "_item_hasChild";
		this.__fieldHasParent = this.__fieldPrefix + "_item_hasParent";
		this.__fieldIsCollapsed = this.__fieldPrefix + "_item_isCollapsed";
		this.__fieldItemArrow = this.__fieldPrefix + "_item_arrow";
		
		this.__isShiftPressed = false;
		this.__isCtrlPressed = false;
		
		this.__objGrid = null;
		this.__nsListFilter = null;
		this.__nsListDragDrop = null;
		this.__nsToolTipInElement = null;
		
		this.__keyDownRef = null;
		this.__keyUpRef = null;
		this.base.__setBaseComponent.call(this,component);
	};
	nsExtendPrototype(NSContainerBase,NSList);
	NSList.prototype.constructor = NSList;
	
	NSList.prototype.initializeComponent = function() 
	{
		this.base.initializeComponent.call(this);
		this.__setSetting();
		this.__initializePluggins();
	};
	
	NSList.prototype.setComponentProperties = function() 
	{
		this.base.setComponentProperties.call(this);
		this.__objGrid.__addSVGInPage();
		this.__setTemplate();
		this.__objGrid.__initialize();
		this.__addListenerForBody();
		if(this.__dataSource)
		{
			this.dataSource(this.__dataSource);
		}
		if(!window["nsListMap"])
		{
			window["nsListMap"] = {};
		}
		window["nsListMap"][this.getID()] = this;
	};
	
	NSList.prototype.propertyChange = function(attrName, oldVal, newVal, setProperty)
	{
		var attributeName = attrName.toLowerCase();
		this.base.propertyChange.call(this,attrName, oldVal, newVal, setProperty);
	};
	
	NSList.prototype.removeComponent = function() 
	{
		if(this.__keyDownRef)
		{
			this.util.removeEvent(document,"keydown",this.__keyDownRef);
			this.__keyDownRef = null;
		}
		if(this.__keyUpRef)
		{
			this.util.removeEvent(document,"keyup",this.__keyUpRef);
			this.__keyUpRef = null;
		}
		if(this.__scroller)
		{
			this.__scroller.__destroyElements();
			this.__scroller = null;
		}
		this.base.removeComponent.call(this);
	};
	
	NSList.prototype.componentResized = function(event) 
	{
		this.base.componentResized.call(this,event);
	};
	
	NSList.prototype.expandAll = function()
	{
		if(this.__enableHierarchical)
		{
			this.__expandCollapseAll(false);
		}
	};
	
	NSList.prototype.collapseAll = function()
	{
		if(this.__enableHierarchical)
		{
			this.__expandCollapseAll(true);
		}
	};
	
	NSList.prototype.setContextMenuSetting = function(contextMenuSetting)
	{
		this.__contextMenuSetting = contextMenuSetting;
	};
	
	NSList.prototype.__setSetting = function()
	{
		var setting = this.__setting;
		if(setting)
		{
			if(setting.hasOwnProperty("enableHierarchical"))
			{
				this.__enableHierarchical = Boolean.parse(setting["enableHierarchical"]);
			}
			if(setting.hasOwnProperty("enableVirtualScroll"))
			{
				this.__enableVirtualScroll = Boolean.parse(setting["enableVirtualScroll"]);
			}
			if(setting.hasOwnProperty("enableDragDrop"))
			{
				if(!this.__enableVirtualScroll)
				{
					this.__enableDragDrop = Boolean.parse(setting["enableDragDrop"]);
				}
			}
			if(setting.hasOwnProperty("isDraggable"))
			{
				this.__isDraggable = Boolean.parse(setting["isDraggable"]);
			}
			if(setting.hasOwnProperty("isDroppable"))
			{
				this.__isDroppable = Boolean.parse(setting["isDroppable"]);
			}
			if(setting.hasOwnProperty("enableDragByHandle"))
			{
				this.__enableDragByHandle = Boolean.parse(setting["enableDragByHandle"]);
			}
			if(setting.hasOwnProperty("dragHandlerClass"))
			{
				this.__dragHandlerClass = setting["dragHandlerClass"];
			}
			if(setting.hasOwnProperty("enableDragAfterHold"))
			{
				this.__enableDragAfterHold = Boolean.parse(setting["enableDragAfterHold"]);
			}
			if(setting.hasOwnProperty("holdTime"))
			{
				this.__holdTime = parseInt(setting["holdTime"]);
			}
			if(setting.hasOwnProperty("enableCloneMode"))
			{
				this.__enableCloneMode = Boolean.parse(setting["enableCloneMode"]);
			}
			if(setting.hasOwnProperty("labelField"))
			{
				this.__labelField = setting["labelField"];
			}
			if(setting.hasOwnProperty("itemRenderer"))
			{
				this.__itemRenderer = setting["itemRenderer"];
				this.__itemRenderer = this.util.getFunction(this.__itemRenderer);
			}
			if(setting.hasOwnProperty("template"))
			{
				this.__templateID = setting["template"];
			}
			if(setting.hasOwnProperty("setData"))
			{
				this.__setData = setting["setData"];
			}
			if(setting.hasOwnProperty("labelFunction"))
			{
				this.__labelFunction = setting["labelFunction"];
				this.__labelFunction = this.util.getFunction(this.__labelFunction);
			}
			if(setting.hasOwnProperty("enableMultipleSelection"))
			{
				this.__enableMultipleSelection =  Boolean.parse(setting["enableMultipleSelection"]);
			}
			if(setting.hasOwnProperty("enableCustomScrollBar"))
			{
				this.__enableCustomScrollBar =  Boolean.parse(setting["enableCustomScrollBar"]);
			}
			if(setting.hasOwnProperty("enableKeyboardNavigation"))
			{
				this.__enableKeyboardNavigation =  Boolean.parse(setting["enableKeyboardNavigation"]);
			}
			if(setting.hasOwnProperty("enableMouseHover"))
			{
				this.__enableMouseHover =  Boolean.parse(setting["enableMouseHover"]);
			}
			if(setting.hasOwnProperty("enableMouseHoverAnimation"))
			{
				this.__enableMouseHoverAnimation =  Boolean.parse(setting["enableMouseHoverAnimation"]);
			}
			if(setting.hasOwnProperty("disableHoverField"))
			{
				this.__disableHoverField = setting["disableHoverField"];
			}
			if(setting.hasOwnProperty("disableHoverFunction"))
			{
				this.__disableHoverFunction = setting["disableHoverFunction"];
				this.__disableHoverFunction = this.util.getFunction(this.__disableHoverFunction);
			}
			if(setting.hasOwnProperty("rowHeight"))
			{
				this.__rowHeight =  parseInt(setting["rowHeight"]);
			}
			if(setting.hasOwnProperty("noDataMessage"))
			{
				this.__noDataMessage = setting["noDataMessage"];
			}
			if(setting.hasOwnProperty("dataSource"))
			{
				this.__dataSource = setting["dataSource"];
			}
			if(setting.hasOwnProperty("childField"))
			{
				this.__childField = setting["childField"];
			}
			if(setting.hasOwnProperty("enableContextMenu"))
			{
				this.__enableContextMenu = Boolean.parse(setting["enableContextMenu"]);
			}
			if(setting.hasOwnProperty("contextMenuProvider"))
			{
				this.__contextMenuProvider =  setting["contextMenuProvider"];
				this.__contextMenuProvider = this.util.getFunction(this.__contextMenuProvider);
			}
			if(setting.hasOwnProperty("enableVariableRowHeight"))
			{
				this.__enableVariableRowHeight =  Boolean.parse(setting["enableVariableRowHeight"]);
			}
			if(setting.hasOwnProperty("customScrollBarSetting"))
			{
				this.__customScrollBarSetting =  setting["customScrollBarSetting"];
			}
			else
			{
				this.__customScrollBarSetting = {enableTooltip: false,toolTipLabelFunction: null,verticalScrollButtons: {enable: false},horizontalScrollButtons:{enable: false}};
			}
			if(setting.hasOwnProperty("virtualScrollSetting"))
			{
				this.__virtualScrollSetting = setting["virtualScrollSetting"];
			}
			else
			{
				this.__virtualScrollSetting = {pageSize: null,pagesRendered: null,enableScrollDelay: false,scrollInterval: null,resizeInterval: null,enableLoader: false,getLoaderComponent: null};
			}
		}
	};
	
	NSList.prototype.dataSource = function(source)
	{
		this.__dataSource = source;
		if(this.__listContainer)
		{
			this.util.removeAllChildren(this.__listContainer);
		}
		else
		{
			this.__createStructure();
		}
		if(this.__dataSource && this.__dataSource.length > 0)
		{
			this.__orignalItemKey = Object.keys(this.__dataSource[0]);
			this.__objGrid.dataSource();
		}
		else
		{
			this.__arrWrapper = [];
			this.__arrInternalSource = [];
			this.__updateTotalRecords(0);
		}
		this.__renderBody();
	};
	
	NSList.prototype.getOrignalItem = function(item)
	{
		if(item && this.__orignalItemKey && this.__orignalItemKey.length > 0)
		{
			var retItem = {};
			var key = null;
			for(var count = 0;count < this.__orignalItemKey.length;count++)
			{
				key = this.__orignalItemKey[count];
				retItem[key] = item[key];
			}
			return retItem;
		}
		return item;
	};
	
	NSList.prototype.addItems = function(arrItem)
	{
		this.__addItem(arrItem);
	};
	
	NSList.prototype.addItemsAsChildren = function(item,arrChildren)
	{
		this.__objGrid.addItemsAsChildren(item,arrChildren);
	};
	
	NSList.prototype.removeItems = function(arrObject)
	{
		if(arrObject && arrObject.length > 0)
		{
			var arrIndex = [];
			if(this.util.isNumber(arrObject[0]))
			{
				arrIndex = arrObject;
			}
			else
			{
				for (var count = 0;count < arrObject.length;count++)
			    {
					var item = arrObject[count];
					if(item && item[this.__fieldIndex])
					{
						arrIndex.push(item[this.__fieldIndex]);
					}
			    }
			}
			arrIndex.sort();
	   	 	for (var rowIndex = arrIndex.length - 1; rowIndex >= 0; rowIndex--)
		    {
	   	 		var index = arrIndex[rowIndex];
	   	 		if(index > 0 && index < this.__arrInternalSource.length)
	   	 		{
		   	 		//if virtual scroll or Pagination of type Page is enabled then do not remove rows
		   	 		if(!this.__enableVirtualScroll)
		   	 		{
		   	 			this.__listContainer.removeChild(this.__listContainer.childNodes[index]);
		   	 		}
		   	 		this.__arrInternalSource.splice(index, 1);
		   	 		this.__arrWrapper.splice(index, 1);
	   	 		}
		    }
		 	this.__updateTotalRecords();
		}
	};
	
	NSList.prototype.scrollToIndex = function(selectedIndex,animationRequired)
	{
		selectedIndex = parseInt(selectedIndex);
		var source = this.__objGrid.__getFlatSource();
		if(selectedIndex > -1 && source && selectedIndex < source.length)
		{
			var item = this.__getItemByIndex(selectedIndex);
			if(item)
			{
				if(this.__enableVirtualScroll)
				{
					if(this.__enableCustomScrollBar)
					{
						var targetDimension = this.__virtualRowHeight * (selectedIndex - 1);
						this.__setVirtualScroll_ScrollTop(targetDimension);
					}
					else
					{
						//var item = this.__getVisibleItemByIndex(this.__arrInternalSource,selectedIndex);
						if(this.__nsVirtualScroll)
						{
							//because in list index is index+1
							this.__nsVirtualScroll.scrollToIndex(selectedIndex - 1,animationRequired);
						}
					}
				}
				else
				{
					if(item[this.__fieldItem])
					{
						var targetDimension = item[this.__fieldItem].offsetTop;
						var scrollTarget = this.__divOuterContainer;
						if(animationRequired)
						{
							var animation = new this.util.animation(scrollTarget,[
				       	  	    {
				       	  	      time: 500,
				       	  	      property:"scrollTop",
				       	  	      target: targetDimension,
				       	  	    }
				       	  	]);
				   	  	  	animation.animate();
						}
						else
						{
							scrollTarget.scrollTop = targetDimension;
						}
					}
				}
			}
		}
	};
	
	NSList.prototype.setSelectedItems = function(arrItems)
	{
		if(arrItems && arrItems.length > 0)
		{
			var source = this.__objGrid.__getFlatSource();
			if(source)
			{
				this.__clearAllRowSelection(false);
				var length = arrItems.length;
				var item = null;
				var index = -1;
				for(var count = 0;count < length;count++)
				{
					item = arrItems[count];
					index = this.__getIndexByItem(item);
					if(index > -1 && source && index < source.length)
					{
						this.__setIndex(index,true);
					}
				}
			}
		}
	};
	
	NSList.prototype.setSelectedItem = function(arrItems)
	{
		this.setSelectedItems([arrItems]);
	};
	
	NSList.prototype.setSelectedIndexes = function(arrSelectedIndex)
	{
		if(arrSelectedIndex && arrSelectedIndex.length > 0)
		{
			var source = this.__objGrid.__getFlatSource();
			if(source)
			{
				var length = arrSelectedIndex.length;
				var index = -1;
				for(var count = 0;count < length;count++)
				{
					index = arrSelectedIndex[count];
					if(index > -1 && source && index < source.length)
					{
						this.__setIndex(index,true);
					}
				}
			}
		}
	};
	
	NSList.prototype.setSelectedIndex = function(selectedIndex)
	{
		this.setSelectedIndexes([selectedIndex]);
	};
	
	NSList.prototype.unSelectItems = function(arrItems)
	{
		
	};
	
	NSList.prototype.unSelectItem = function(arrItems)
	{
		this.unSelectItems([arrItems]);
	};
	
	NSList.prototype.unSelectIndexes = function(arrSelectedIndex)
	{
		
	};
	
	NSList.prototype.unSelectIndex = function(selectedIndex)
	{
		this.unSelectIndexes([selectedIndex]);
	};
	
	NSList.prototype.getSelectedIndex = function()
	{
		return this.__selectedIndex;
	};
	
	NSList.prototype.getSelectedItem = function()
	{
		return this.__selectedItem;
	};
	
	NSList.prototype.getSelectedIndexes = function()
	{
		return this.__selectedIndexes;
	};
	
	NSList.prototype.getSelectedItems = function()
	{
		return this.__selectedItems;
	};
	
	NSList.prototype.deselectAll = function()
	{
		this.__clearAllRowSelection(true);
	};
	
	NSList.prototype.filter = function(strData,setting,enableHighlighting,recordLimit)
	{
		this.__nsListFilter.filter(strData,setting,enableHighlighting,recordLimit);
	};
	
	NSList.prototype.resetFilter = function()
	{
		this.__nsListFilter.reset();
	};
	
	NSList.prototype.updateListItemByIndex = function(index)
	{
		var item = this.__getItemByIndex(index);
		if(item)
		{
			var listItem = this.__getListItemFromItem(item);
			if(listItem)
			{
				var index = this.__getIndexByItem(item);
				this.__updateListItemText(listItem,item,index);
			}
		}
	};
	
	NSList.prototype.__highlightDiv = function(divText)
	{
		this.__nsListFilter.__highlightDiv(divText);
	};
	
	NSList.prototype.__initializePluggins = function()
	{
		if(!this.__objGrid)
		{
			if(this.__enableHierarchical)
			{
				this.__objGrid = new NSHierarchicalList(this);
			}
			else
			{
				this.__objGrid = new NSFlatList(this);
			}
		}
		if(!this.__nsListFilter)
		{
			this.__nsListFilter = new NSListFilter(this);
			if(this.__enableDragDrop)
			{
				this.__nsListDragDrop = new NSListDragDrop(this);
			}
		}
		this.__nsToolTipInElement = new this.util.nsToolTipInElement();
	};
	
	NSList.prototype.__createStructure = function()
	{
		if(!this.__divOuterContainer)
		{
			this.__divOuterContainer = this.util.createDiv(this.getID() + "container","nsListOuterContainer");
			if(this.__enableHierarchical)
			{
				this.util.addStyleClass(this.__divOuterContainer,"nsListOuterContainerHierarchical")
			}
			this.__divOuterContainer.style.width = this.util.getStyleValue(this.__baseComponent,"width");
			//this.__divOuterContainer.style.height = this.util.getStyleValue(this.__baseComponent,"height");
			this.addChild(this.__divOuterContainer);
			this.__divParentContainer = this.util.createDiv(this.getID() + "parentContainer","nsListParentContainer");
			this.__divOuterContainer.appendChild(this.__divParentContainer);
			this.__listContainer = this.util.createElement("ul",this.getID() + "list","nsListContainer");
			this.__listContainer.style.minHeight = (this.__divOuterContainer.clientHeight - 10) + "px";
			this.__divParentContainer.appendChild(this.__listContainer);
			if(this.__enableVirtualScroll)
			{
				this.util.addStyleClass(this.__divParentContainer,"nsListBodyContainerVirtual");
			}
			this.__createCustomScroller();
		}
	};

	NSList.prototype.__renderBody = function()
	{
		this.__navigationIndex = -1;
		if(this.__enableContextMenu)
		{
			this.__initializeContextMenu();
		}
		if(this.__enableVirtualScroll)
		{
			this.__setNSVirtualScroll(this.__arrInternalSource);
		}
		else
		{
			this.util.removeAllChildren(this.__listContainer);
			this.__createList(this.__arrInternalSource,0,this.__arrInternalSource.length);
			//5 is offset for number of rows
			var listItem = this.__getListItemByIndex(0);
			if(listItem)
			{
				this.__listItemHeight = listItem.clientHeight;
			}
			this.__pageSize = (this.__divOuterContainer.clientHeight/this.__listItemHeight) - 5;
			this.__startArrayElement = 0;
		}
		//this.__listContainer.scrollTop = 0;
		if(this.__nsListDragDrop)
		{
			this.__nsListDragDrop.initialize();
		}
	};
	
	NSList.prototype.__setNSVirtualScroll = function(source)
	{
		var length = 0;
		if(source && source.length)
		{
			for(var count = 0;count < source.length;count++)
			{
				if(source[count][this.__fieldItemVisible])
				{
					length++;
				}
			}
		}
		if(this.__nsVirtualScroll)
		{
			this.__nsVirtualScroll.dataSource(length);
		}
		else
		{
			if(length > 0)
			{
				if(this.__rowHeight > 0)
				{
					this.__virtualRowHeight = this.__rowHeight;
				}
				else
				{
					this.__createList(this.__arrInternalSource,0,1);
					var item = this.__arrInternalSource[0];
					var listItem = item[this.__fieldItem];
				    this.__virtualRowHeight = listItem.offsetHeight;
				    listItem.parentNode.removeChild(listItem);
				}
				var setting = {scrollElement: this.__divOuterContainer,contentElement: this.__listContainer,itemTag: "li",totalLength: length,getItemComponent:this.__getItemComponentForVirtual.call(this),getEmptyItemComponent:this.__getEmptyItemComponentForVirtual.call(this)};
				var virtualScrollSetting = this.__virtualScrollSetting;
				var arrCopyFields = ["pageSize","pagesRendered","enableScrollDelay","scrollInterval","resizeInterval","enableLoader","getLoaderComponent"];
				var field = null;
				for(var count = 0;count < arrCopyFields.length;count++)
				{
					field = arrCopyFields[count];
					if(!this.util.isUndefinedOrNull(virtualScrollSetting[field]))
					{
						setting[field] = virtualScrollSetting[field];
					}
				}
				this.__nsVirtualScroll = new NSVirtualScroll(setting);
			}
		}
	};
	
	NSList.prototype.__getItemComponentForVirtual = function()
	{
		var list = this;
		var CreateListItem = function(index)
		{
			this.__index = index;
			this.__list =  list;
			this.__item = null;
			this.__listItem = null;
		};
		CreateListItem.prototype.getElement = function()
		{
			if(!this.__listItem)
			{
				if(this.__list.__enableHierarchical)
				{
					this.__item = this.__list.__getVisibleItemByIndex(null,this.__index);
				}
				else
				{
					this.__item = this.__list.__arrInternalSource[this.__index];
				}
				this.__listItem = this.__list.__createListItem(this.__item,false);
			}
			return this.__listItem;
		};
		return CreateListItem;
	};
	
	NSList.prototype.__getEmptyItemComponentForVirtual = function()
	{
		var list = this;
		var CreateEmptyListItem = function()
		{
			this.__list =  list;
			this.__listItem = null;
		};
		CreateEmptyListItem.prototype.getElement = function()
		{
			if(!this.__listItem)
			{
				this.__listItem = this.__list.__createNoDataRow.call(this.__list);
			}
			return this.__listItem;
		};
		return CreateEmptyListItem;
	};
	
	NSList.prototype.__createCustomScroller = function()
	{
		if(this.__enableCustomScrollBar && !this.__scroller)
		{
			var setting = {element: this.__divOuterContainer,enableCustomHandler: true,verticalScrollButtons:this.__customScrollBarSetting.verticalScrollButtons,horizontalScrollButtons:this.__customScrollBarSetting.horizontalScrollButtons};
			for (var key in setting) 
			{ 
				this.__scrollerSetting[key] = setting[key]; 
			}
			this.__scroller = new NSScroller(this.__scrollerSetting);
			this.util.addEvent(this.__scrollerSetting.element,NSScroller.SCROLLING,this.__customScrollHandler.bind(this));
			this.util.addEvent(this.__scrollerSetting.element,NSScroller.SCROLL_END,this.__customScrollEndHandler.bind(this));
		}
	};
	
	NSList.prototype.__customScrollHandler = function(event)
	{
		var self = this;
		var virtualVerHandler = function()
		{
			//todo Virtual Scroll impl for Custom Scroll Bar
		};
		var dataRefreshVerHandler = function()
		{
			
		};
		var asyncLoadVerHandler = function()
		{
			
		};
		var paginationVerHandler = function()
		{
			
		};
		var normalVerHandler = function()
		{
			self.__divOuterContainer.scrollTop = scrollPos;
			
			var first,last;
			var arrRows = self.__listContainer.querySelectorAll("li");
			for(var count = 0;count < arrRows.length;count++)
			{
				var li = arrRows[count];
				if(isInViewport(li))
				{
					first = li;
					break;
				}
			}
			for(;count < arrRows.length;count++)
			{
				var li = arrRows[count];
				if(!isInViewport(li))
				{
					break;
				}
				last = li;
			}
			console.log(first,last);
		};
		var normalHorHandler = function()
		{
			self.__divOuterContainer.scrollLeft = scrollPos;
		};
		var isInViewport = function (elem) 
		{
			if(elem)
			{
				/*var distance = elem.getBoundingClientRect();
				return (
					distance.top >= 0 &&
					distance.left >= 0 &&
					distance.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
					distance.right <= (window.innerWidth || document.documentElement.clientWidth)
				);*/
				const rect = elem.getBoundingClientRect();
			    const windowHeight = (window.innerHeight || document.documentElement.clientHeight);
			    const windowWidth = (window.innerWidth || document.documentElement.clientWidth);

			    const vertInView = (rect.top <= windowHeight) && ((rect.top + rect.height) >= 0);
			    const horInView = (rect.left <= windowWidth) && ((rect.left + rect.width) >= 0);

			    return (vertInView && horInView);
			}
			return false;
		};
		var objCondition = {virtualScroll:{eligible:this.__enableVirtualScroll,verHandler:virtualVerHandler,horHandler:normalHorHandler},
							dataRefreshOnEnd:{eligible:this.__enableDataRefreshOnScrollEnd,verHandler:dataRefreshVerHandler,horHandler:normalHorHandler},
							asyncLoad:{eligible:this.__enableAsyncLoadPagination,verHandler:asyncLoadVerHandler,horHandler:normalHorHandler},
							pagination:{eligible:(this.__enablePagination && this.__isPaginationTypeScroll),verHandler:paginationVerHandler,horHandler:normalHorHandler},
							normal:{eligible:true,verHandler:normalVerHandler,horHandler:normalHorHandler}
						   };
		var eventItem = event;
		var direction = eventItem.direction;
		var scrollPos = eventItem.scrollPos;
		var oldScrollPos = eventItem.oldScrollPos;
		var orignalEvent = eventItem.orignalEvent;
		var scrollBar = eventItem.scrollBar;
		var position = eventItem.absoluteScrollBarPos;
		for(var key in objCondition)
		{
			var item = objCondition[key];
			if(item.eligible)
			{
				if(direction == "vertical")
				{
					if(item.verHandler)
					{
						if(this.__customScrollBarSetting["enableTooltip"] && !this.__customScrollBarTooltip)
						{
							this.__customScrollBarTooltip = this.util.createElement("span",null,"tooltiptext tooltip-left");
							document.body.appendChild(this.__customScrollBarTooltip);
						}
						item.verHandler();
					}
				}
				else
				{
					if(item.horHandler)
					{
						item.horHandler();
					}
				}
				break;
			}
		}
	};
	
	NSList.prototype.__customScrollEndHandler = function(event)
	{
		if(this.__customScrollBarTooltip)
		{
			document.body.removeChild(this.__customScrollBarTooltip);
			this.__customScrollBarTooltip = null;
		}
	};
	
	NSList.prototype.__customScrollTooltipPos = function(scrollbar,position,itemFrom,itemTo)
	{
		if(this.__customScrollBarTooltip)
		{
			var toolTip = this.__customScrollBarTooltip;
			var css = {};
			//5 for the triangle
			css.left = (position.x - toolTip.offsetWidth - 5) + "px";
			css.top = position.y + "px";
			this.util.css(toolTip,css);
			if(this.__customScrollBarSetting.toolTipLabelFunction)
			{
				toolTip.innerHTML = this.__customScrollBarSetting.toolTipLabelFunction(itemFrom,itemTo);
			}
			else
			{
				toolTip.innerHTML = "Showing Record from index " + itemFrom + " to " +  itemTo;
			}
		}
		
	};
	
	NSList.prototype.__virtualRowSelection = function()
	{
		if(this.__listContainer.children && this.__listContainer.children.length > 0 && this.__arrInternalSource)
		{
			var listItem = null;
			var index = null;
			var item = null;
			for(var count = 0; count < this.__listContainer.children.length; count++) 
			{
				listItem = this.__listContainer.children[count];
				index = this.__getIndexFromTarget(listItem);
				item = this.__getItemByIndex(index);
				if(item && this.__isMouseHoverAllowed(index))
				{
					if(item[this.__fieldSelected])
					{
						//DONOT REPLACE WITH __markRowSelected
						this.util.addStyleClass(listItem,"nsListItemSelected"); 
					}
					else
					{
						//DONOT REPLACE WITH __markRowUnselected
						this.util.removeStyleClass(listItem,"nsListItemSelected");
					}
				}
			}
		}
	};
	
	NSList.prototype.__virtualRowHover = function()
	{
		if(this.__listContainer.children && this.__listContainer.children.length > 0 && this.__arrInternalSource)
		{
			var listItem = null;
			var index = null;
			var item = null;
			for(var count = 0; count < this.__listContainer.children.length; count++) 
			{
				listItem = this.__listContainer.children[count];
				index = this.__getIndexFromTarget(listItem);
				item = this.__getItemByIndex(index);
				(item && item[this.__fieldHover]) ? this.util.addStyleClass(listItem,"nsListItemHover") : this.util.removeStyleClass(listItem,"nsListItemHover");
			}
		}
	};
	
	NSList.prototype.__setVirtualRowHoverField = function(indexToSet)
	{
		if(this.util.isUndefinedOrNull(indexToSet))
		{
			indexToSet = -1;
		}
		var source = this.__objGrid.__getFlatSource();
		if(source)
		{
			var item = null;
			for(var count = 0; count < source.length; count++) 
			{
				var item = source[count];
				if(item)
				{
					item[this.__fieldHover] = (item[this.__fieldIndex] === indexToSet); 
				}
			}
		}
	};
	
	NSList.prototype.__setVirtualRowHover = function(indexToSet)
	{
		if(this.__enableVirtualScroll)
		{
			if(this.util.isUndefinedOrNull(indexToSet))
			{
				indexToSet = 0;
			}
			var item = this.__getVisibleItemByIndex(null,indexToSet);
			if(item)
			{
				this.__navigationIndex = indexToSet;
				var index = item[this.__fieldIndex];
				this.__setVirtualRowHoverField(index);
				this.__virtualRowHover();
			}
			
		}
	};
	
	NSList.prototype.__setRowHover = function(indexToSet)
	{
		if(this.util.isUndefinedOrNull(indexToSet))
		{
			indexToSet = 0;
		}
		if(this.__enableVirtualScroll)
		{
			this.__setVirtualRowHover(indexToSet);
		}
		else
		{
			if(this.util.isUndefinedOrNull(indexToSet))
			{
				indexToSet = 0;
			}
			this.__navigationIndex = indexToSet;
			var listItem = this.__getListItemFromContainer(this.__navigationIndex);
			this.util.addStyleClass(listItem,"nsListItemHover");
		}
	};
	
	NSList.prototype.__createNoDataRow = function()
	{
		var listItem = this.util.createElement("li",null,"nsListNoRecordsFound");
		listItem.setAttribute("nsNoData","true");
		var textNode = document.createTextNode(this.__noDataMessage);
		listItem.appendChild(textNode);
		return listItem;
	};
	
	NSList.prototype.__addListenerForBody = function()
	{
		if(!this.__keyDownRef)
		{
			this.__keyDownRef = this.__keyDownHandler.bind(this);
			this.util.addEvent(document,"keydown",this.__keyDownRef);
		}
		if(!this.__keyUpRef)
		{
			this.__keyUpRef = this.__keyUpHandler.bind(this);
			this.util.addEvent(document,"keyup",this.__keyUpRef);
		}
	};
	
	NSList.prototype.__createList = function(dataSet,startIndex,endIndex)
	{
		if(dataSet && dataSet.length > 0)
	    {
			this.__objGrid.__createList(dataSet,startIndex,endIndex);
	    }
		else
		{
			this.__listContainer.appendChild(this.__createNoDataRow());
		}
	};
	
	NSList.prototype.__createListAt = function(item,index,isResetIndex)
	{
		if(item && index > -1)
	    {
			this.__updateItem(item,index,true,isResetIndex);
			var listItem = this.__createListItem(item,false);
			this.__listContainer.insertBefore(listItem, this.__listContainer.childNodes[index]);
			return listItem;
	    }
		return null;
	};
	
	NSList.prototype.__updateItem = function(item,index,isReset,isResetIndex)
	{
		if(item)
		{
			if(isResetIndex || !item.hasOwnProperty(this.__fieldIndex))
			{
				item[this.__fieldIndex] = index;
			}
			if(isReset || !item.hasOwnProperty(this.__fieldDisableHover))
			{
				item[this.__fieldDisableHover] = this.__isHoverDisabled(item);
			}
			if(isReset || !item.hasOwnProperty(this.__fieldSelected))
			{
				item[this.__fieldSelected] = false;
			}
		}
	};
	
	NSList.prototype.__createListItem = function(item,isAdd)
	{
		if(item)
		{
			 if(this.util.isUndefined(isAdd) || isAdd === null)
			 {
				 isAdd = true;
			 }
			 var listItem = this.util.createElement("li",null,"nsListItem");
			 this.__objGrid.__createListItem(listItem,item);
			 if(this.__enableMouseHover)
			 {
				 this.util.addEvent(listItem,"mouseover",this.__itemMouseOverHandler.bind(this));
				 this.util.addEvent(listItem,"mouseout",this.__itemMouseOutHandler.bind(this));
				 if(this.__enableMouseHoverAnimation)
				 {
					 this.util.addStyleClass(listItem,"nsListItemAnimated");
				 }
				 else
				 {
					 this.util.addStyleClass(listItem,"nsListItemNormal");
				 }
			 }
			 this.util.addEvent(listItem,"click",this.__itemClickHandler.bind(this));
			 this.__setListItemProperties(listItem,item);
			 if(isAdd)
			 {
				 this.__listContainer.appendChild(listItem);
			 }
			 return listItem;
		}
		return null;
	};
	
	NSList.prototype.__setListItemProperties = function(listItem,item)
	{
		this.__objGrid.__setListItemProperties(listItem,item);
	};
	
	NSList.prototype.__addCellText = function(listItem,item,div)
	{
		var toolTipText = null;
		if(listItem && item && div)
		{
			if(this.__itemRenderer)
			{
				var objRenderer = this.__itemRenderer(item,this.__labelField,item[this.__fieldIndex],item[this.__fieldDisableHover],listItem);
				if(objRenderer)
				{
					if(this.util.isString(objRenderer))
					{
						var compBodySpan = document.createElement("span");
						compBodySpan.innerHTML = objRenderer;
						div.appendChild(compBodySpan);
					}
					else
					{
						div.appendChild(objRenderer);
					}
				}
			}
			else if(this.__template)
			{
				div.appendChild(this.__template.cloneNode(true));
				this.__setDataInTemplateRenderer(div,item,listItem);
			}
			else if(this.__labelFunction)
			{
				var text = this.__labelFunction(item,this.__labelField);
				div.appendChild(document.createTextNode(text));
			}
			else if(item.hasOwnProperty(this.__labelField) && !this.util.isUndefined(item[this.__labelField]) && item[this.__labelField] != null)
		    {
				var text = item[this.__labelField];
				div.appendChild(document.createTextNode(text));
		    }
			this.__highlightDiv(div);
			if(this.__toolTipField)
			{
				toolTipText = item[this.__toolTipField];
			}
			else if(this.__toolTipRenderer)
			{
				toolTipText = this.__toolTipRenderer(item,this.__labelField,item[this.__fieldIndex],item[this.__fieldDisableHover],listItem);
			}
			if(this.__enableTruncateToFit)
			{
				this.util.addStyleClass(div,"nsListTruncateToFit");
				//This condition is above so that toolTip and title are not set togeather
				if(!toolTipText || toolTipText === "")
				{
					if(this.__enableToolTipForTruncateText)
					{
						toolTipText = div.textContent;
					}
					else
					{
						div.setAttribute("title",div.textContent);
					}
				}
			}
			if(toolTipText && toolTipText !== "")
			{
				this.__nsToolTipInElement.addToolTip(div,toolTipText);
			}
		}
	};
	
	NSList.prototype.__setDataInTemplateRenderer = function(cellItem,data,listItem)
	{
		if(cellItem && this.__setData)
		{
			this.__setRendererProperties(cellItem);
			this.__setRendererInData(cellItem,data,listItem);
			//IE bug
			cellItem.data = data;
			if(this.util.isFunction(this.__setData))
		    {
				var strParam = "(cellItem,data,dataField,isDisabled,listItem)"; 
		    	if(this.util.isString(this.__setData))
		    	{
		    		var base = this;
		    		this.util.callFunctionFromString(this.__setData + strParam,function(paramValue){
						if(paramValue === "cellItem")
						{
							return cellItem;
						}
						if(paramValue === "data")
						{
							return data;
						}
						if(paramValue === "dataField")
						{
							return base.__labelField;
						}
						if(paramValue === "isDisabled")
						{
							return data[base.__fieldDisableHover];
						}
						if(paramValue === "listItem")
						{
							return listItem;
						}
						return paramValue;
					});
		    	}
		    	else
		    	{
		    		this.__setData(cellItem,data,this.__labelField,data[this.__fieldDisableHover],listItem);
		    	}
		    }
		}
	};
	
	NSList.prototype.__setRendererInData = function(cellItem,data,listItem)
	{
		if(cellItem)
		{
			var compChild = null;
			for(var count = 0; count < cellItem.children.length; count++) 
			{
				compChild = cellItem.children[count];
				if(compChild)
				{
					compChild.data = data;
					compChild.listItem = listItem;
				}
				//IE 9 Bug,you got to assign it back
				//listItem.children[count] = compChild;
				this.__setRendererInData(compChild,data,listItem);
			}
		}
	};
	
	NSList.prototype.__setRendererProperties = function(cellItem)
	{
		if(cellItem)
		{
			var compChild = null;
			for(var count = 0; count < cellItem.children.length; count++) 
			{
				compChild = cellItem.children[count];
				var grid = this;
				Array.prototype.slice.call(compChild.attributes).forEach(function(attribute) 
				{
			        if(grid.util.isFunction(attribute.value))
			        {
			        	var newValue = attribute.value + "(this)";
			        	compChild.removeAttribute(attribute.name);
						compChild.setAttribute(attribute.name,newValue);
			        }
				});
				if(compChild)
				{
					if(compChild.hasAttribute("accessor-name"))
					{
						cellItem[compChild.getAttribute("accessor-name")] = compChild;
					}
				}
				this.__setRendererProperties(compChild);
			}
		}
	};
	
	NSList.prototype.__setTemplate = function()
	{
		if(this.__templateID)
		{
			this.__template = this.util.getTemplate(this.__templateID);
		}
	};
	
	NSList.prototype.__isHoverDisabled = function(item)
	{
		if(this.__disableHoverField)
		{
			return Boolean.parse(item[this.__disableHoverField]);
		}
		if(this.__disableHoverFunction)
		{
			return Boolean.parse(this.__disableHoverFunction(item,this.__fieldIndex));
		}
		return false;
	};
	
	NSList.prototype.__itemClickHandler = function(event)
	{
		event = this.util.getEvent(event);
	    var target = this.util.getTarget(event);
	    target = this.util.findParent(target,"li");
	    var index = this.__getIndexFromTarget(target);
	    this.__setIndex(index,false);
	    this.__lastNavigationDirection = null;
	};
	
	NSList.prototype.__setIndex = function(index,isMultiSelect)
	{
		if(index > -1)
		{
			isMultiSelect = Boolean.parse(isMultiSelect);
			if (this.__isShiftPressed && this.__enableMultipleSelection)
		    {
		    	this.__multiSectionHandler(index);
		    }
		    else if(isMultiSelect || (this.__isCtrlPressed && this.__enableMultipleSelection))
		    {
		    	if(this.__isRowSelected(index))
		    	{
		    		this.__markRowUnselected(index);
		    	}
		    	else
		    	{
		    		this.__markRowSelected(index);
		    	}
		    }
		    else
		    {
		    	this.__clearAllRowSelection(false);
		    	this.__markRowSelected(index);
		    } 
		}
	};
	
	NSList.prototype.__itemMouseOverHandler = function(event)
	{
		 var target = this.util.getTarget(event);
	     target = this.util.findParent(target,"li");
	     var index = this.__getIndexFromTarget(target);
	     var item = this.__getItemByIndex(index);
	     if(target && index > -1 && this.__isMouseHoverAllowed(index))
	     {
	    	 this.util.addStyleClass(target,"nsListItemHover");
	    	 this.__navigationIndex = index;
	    	 this.util.dispatchEvent(this.__baseComponent,this.ITEM_NAVIGATED,item,{index:this.__navigationIndex});
	     }
	};
	
	NSList.prototype.__itemMouseOutHandler = function(event)
	{
		 var target = this.util.getTarget(event);
	     target = this.util.findParent(target,"li");
	     if(target)
	     {
	    	 this.util.removeStyleClass(target,"nsListItemHover");
	     }
	};
	
	NSList.prototype.__keyDownHandler = function(event)
	{
		event = this.util.getEvent(event);
		if(this.hasFocus())
		{
			this.__isShiftPressed = event.shiftKey;
			this.__isCtrlPressed = event.ctrlKey;
			var isShiftCtrlPressed = this.__isShiftPressed || this.__isCtrlPressed;
			var keyCode = this.util.getKeyUnicode(event);
			if(this.__enableKeyboardNavigation)
			{
				var source = this.__objGrid.__getFlatSource();
				//key Up
				if(keyCode === this.util.KEYCODE.UP && isShiftCtrlPressed && this.__enableMultipleSelection)
				{
					if(this.__lastNavigationDirection && this.__lastNavigationDirection === this.NAVIGATION_DOWN)
					{
						return this.__keyBoardSelectionHandler(event,this.NAVIGATION_UP);
					}
					if(this.__selectedIndex != 0)
					{
						this.__selectedIndex--;
						this.__navigationIndex--;
						while(!this.__isMouseHoverAllowed(this.__selectedIndex))
						{
							this.__selectedIndex--;
							this.__navigationIndex--;
						}
						return this.__keyBoardSelectionHandler(event,this.NAVIGATION_UP);
					}
				}
				//key down
				else if(keyCode === this.util.KEYCODE.DOWN && isShiftCtrlPressed && this.__enableMultipleSelection)
				{
					if(this.__lastNavigationDirection && this.__lastNavigationDirection === this.NAVIGATION_UP)
					{
						return this.__keyBoardSelectionHandler(event,this.NAVIGATION_DOWN);
					}
					if(source && this.__selectedIndex != source.length - 1)
					{
						this.__selectedIndex++;
						this.__navigationIndex++;
						while(!this.__isMouseHoverAllowed(this.__selectedIndex))
						{
							this.__selectedIndex++;
							this.__navigationIndex++;
						}
						return this.__keyBoardSelectionHandler(event,this.NAVIGATION_DOWN);
					}
				}
				else if(keyCode === this.util.KEYCODE.UP)
				{
					if(source && this.__navigationIndex === -1)
					{
						this.__navigationIndex = source.length - 1;
					}
					if(this.__navigationIndex > 0)
					{
						return this.__keyBoardNavigationHandler(event,this.NAVIGATION_UP);
					}
				}
				else if(keyCode === this.util.KEYCODE.DOWN)
				{
					/*if(this.__navigationIndex === -1)
					{
						this.__navigationIndex = 0;
					}*/
					if(source)//&& this.__navigationIndex < source.length
					{
						return this.__keyBoardNavigationHandler(event,this.NAVIGATION_DOWN);
					}
				}
				else if(keyCode === this.util.KEYCODE.ENTER)
				{
					this.__clearAllRowSelection(false);
					var listItem = this.__getkeyboardNavigationListItem();
					if(listItem)
					{
						this.__markRowSelected(this.__getIndexFromTarget(listItem));
					}
				}
			}
			if(keyCode === this.util.KEYCODE.SHIFT)
			{
				this.util.makeBodyUnselectable();
			}
		}
	};
	
	NSList.prototype.__keyUpHandler = function(event)
	{
		if(this.util.getKeyUnicode(event) === this.util.KEYCODE.CTRL)
		{
			this.__isCtrlPressed = false;
		}
		if(this.util.getKeyUnicode(event) === this.util.KEYCODE.SHIFT)
		{
			this.__isShiftPressed = false;
			this.util.makeBodySelectable();
		}
	};
	
	NSList.prototype.__keyBoardNavigationHandler = function(event,direction)
	{
		var self = this;
		var lastIndex = this.__navigationIndex;
		var currentIndex = this.__navigationIndex;
		(direction === this.NAVIGATION_UP) ? currentIndex--:currentIndex++;
		while(!this.__isMouseHoverAllowed(currentIndex))
		{
			(direction === this.NAVIGATION_UP) ? currentIndex--:currentIndex++;
		}
		var endHandler = function()
		{
			self.__navigationIndex = currentIndex;
			var listItem = self.__getkeyboardNavigationListItem();
			var index = -1;
			var item = null;
			if(listItem)
			{
				var source = self.__objGrid.__getFlatSource();
				index = self.__getIndexFromTarget(listItem);
				item = self.__getItemByIndex(index, source);
			}
			self.util.dispatchEvent(self.__baseComponent,self.ITEM_NAVIGATED,item,{index:index});
			self.__lastNavigationDirection = null;
		};
		if(this.__enableVirtualScroll)
		{
			
			var virtualHandler = function()
			{
				//self.__setVirtualRowHover.call(self,index);
				var item = self.__getVisibleItemByIndex.call(self,null,currentIndex);
				if(item)
				{
					var index = item[self.__fieldIndex];
					self.__setVirtualRowHoverField.call(self,index);
					self.__virtualRowHover.call(self);
					endHandler();
				}
			};
			this.scrollToIndex(currentIndex,false);
			
			setTimeout(function()
			{ 
				virtualHandler();
			},0);
			//this.__setVirtualRowHover(currentIndex);
		}
		else
		{
			var listItem = this.__getListItemFromContainer(lastIndex - this.__startArrayElement);
			var currentListItem = this.__getListItemFromContainer(currentIndex - this.__startArrayElement);
			//var listItem = this.__getListItemByIndex(lastIndex - this.__startArrayElement);
			//var currentListItem = this.__getListItemByIndex(currentIndex - this.__startArrayElement);
			if(currentListItem)
			{
				this.util.removeStyleClass(listItem,"nsListItemHover");
				this.util.addStyleClass(currentListItem,"nsListItemHover");
				this.__refreshScrollPosition(currentListItem,direction);
				endHandler();
			}
		}
		
		event.preventDefault();
		return false;
	};
	
	NSList.prototype.__keyBoardSelectionHandler = function(event,direction)
	{
		if(this.__isRowSelected(this.__selectedIndex))
		{
			this.__markRowUnselected(this.__selectedIndex);
		}
		else
		{
			this.__markRowSelected(this.__selectedIndex);
		}
		if(direction === this.NAVIGATION_DOWN)
		{
			if(this.__enableVirtualScroll)
			{
				this.scrollToIndex(this.__selectedIndex,false);
			}
			else if(Math.floor(this.__selectedIndex % this.__pageSize) === 0)
			{
				var listItem = this.__getListItemByIndex(this.__selectedIndex);
				this.__refreshScrollPosition(listItem,this.NAVIGATION_DOWN);
			}
		}
		else if(direction === this.NAVIGATION_UP)
		{
			if(this.__enableVirtualScroll)
			{
				this.scrollToIndex(this.__selectedIndex,false);
			}
			else
			{
				var listItem = this.__getListItemByIndex(this.__selectedIndex);
				this.__refreshScrollPosition(listItem,this.NAVIGATION_UP);
			}
		}
		this.__lastNavigationDirection = direction;
		event.preventDefault();
		return false;
	};
	
	NSList.prototype.__refreshScrollPosition = function(listItem,direction)
	{
		if(!this.__isElementInView(listItem))
		{
			this.__scrollToListItem(listItem);
		}
	};
	
	NSList.prototype.__isElementInView = function(listItem)
	{
		var cellBottom = 0;
	    var parentBottom = 0;
	    var cellTop = 0;
	    var parentTop = 0;
		if(listItem)
		{
			var scrollParent = this.__divOuterContainer;
			var listChild = listItem.querySelector(".nsListChild");
			if(scrollParent && listChild)
			{
				var cellRect = listChild.getBoundingClientRect();
	            parentTop = 0;
	            var rectScrollParent = scrollParent.getBoundingClientRect();
	            parentBottom = rectScrollParent.height;
	            cellTop =  cellRect.top - rectScrollParent.top;
	            cellBottom = cellTop + cellRect.height;
			}
		}
		return cellBottom <= parentBottom && cellTop >= parentTop;
	};
	
	NSList.prototype.__scrollToListItem = function(listItem)
	{
		if(listItem)
		{
			var rectCell = listItem.getBoundingClientRect();
			var rectParentContainer = this.__divParentContainer.getBoundingClientRect();
	        var scrollTop = rectCell.top - rectParentContainer.top;
	        this.__divOuterContainer.scrollTop = scrollTop;
		}
	};
	
	NSList.prototype.__getkeyboardNavigationListItem = function()
	{
		var listItem = null;
		if(this.__enableVirtualScroll)
		{
			listItem = this.__listContainer.querySelector(".nsListItemHover");
		}
		else
		{
			listItem = this.__getListItemFromContainer(this.__navigationIndex);
		}
		return listItem;
	};
	
	NSList.prototype.__isMouseHoverAllowed = function(index)
	{
		var item = this.__getItemByIndex(index);
		if(item)
		{
			return !item[this.__fieldDisableHover];
		}
		return true;
	};
	
	NSList.prototype.__markRowSelected= function(index)
	{
		if(index > -1)
	    {
	        if(!this.__isRowSelected(index))
	        {
	        	this.__setMultiSelectedVars(index,true);
	            this.__setValuesForSelectedRow(index);
	        	if(this.__enableVirtualScroll)
	        	{
	        		this.__virtualRowSelection();
	        	}
	        	else
	        	{
	        		var listItem = this.__getListItemByIndex(index);
	            	this.util.addStyleClass(listItem,"nsListItemSelected"); 
	        	}
	        }
	    }
	};
	
	NSList.prototype.__markRowUnselected = function(index)
	{
	    if(this.__isRowSelected(index) && this.__isMouseHoverAllowed(index))
	    {
	    	var isUnselected = this.__setMultiSelectedVars(index,false);
	        if(isUnselected)
	        {
	        	this.__setValuesForUnselectedRow(index);
	        }
	        if(this.__enableVirtualScroll)
	    	{
	    		this.__virtualRowSelection();
	    	}
	    	else
	    	{
	    		var listItem = this.__getListItemByIndex(index);
	    		this.util.removeStyleClass(listItem,"nsListItemSelected");
	    	}
	    }
	};
	
	NSList.prototype.__setValuesForSelectedRow = function(index)
	{
		if(index > -1 && this.__isMouseHoverAllowed(index))
		{
			var item = this.__getItemByIndex(index);
			if(item)
			{
				item[this.__fieldSelected] = true;
			    this.__selectedIndex = index;
			    this.__navigationIndex = index;
			    this.util.dispatchEvent(this.__baseComponent,this.ITEM_SELECTED,item,{index:index});
			}
		}
	};
	
	NSList.prototype.__setValuesForUnselectedRow = function(index)
	{
		if(index > -1 && this.__isMouseHoverAllowed(index))
		{
			var item = this.__getItemByIndex(index);
			if(item)
			{
				item[this.__fieldSelected] = false;
		    	this.util.dispatchEvent(this.__baseComponent,this.ITEM_UNSELECTED,item,{index:index});
			}
		}
	};
	
	NSList.prototype.__clearAllRowSelection = function(setIndexVariables)
	{
		var size = this.__selectedIndexes.length;
	    for (var count = size - 1; count >= 0 ; count--)
	    {
	    	var index = this.__selectedIndexes[count];
	        this.__markRowUnselected(index);
	    }
	    this.__setMultiSelectedVars(-1,true);
	    if(setIndexVariables)
	    {
	    	this.__selectedIndex = -1;
	        this.__navigationIndex = -1;
	    }
	};
	
	NSList.prototype.__multiSectionHandler = function(lastIndex)
	{
		 if(lastIndex < 0)
		 {
			 return;
		 }
		 if (this.__selectedIndexes.length === 0)
		 {
			 this.__isRowSelected(lastIndex);
		     return;
		 }
		 var firstIndex = this.__selectedIndexes[this.__selectedIndexes.length - 1];
		 if(lastIndex === firstIndex)
		 {
			 this.__markRowUnselected(lastIndex);
			 return;
		 }
		 var isDown = lastIndex > firstIndex;
		 var isSelection = !this.__isRowSelected(lastIndex);
		 var counter = firstIndex;
		 do
		 {
			  counter = isDown ? (counter + 1) : (counter - 1);
			  if (isSelection)
			  {
				  this.__markRowSelected(counter);
			  }
			  else
			  {
				  this.__markRowUnselected(counter);
			  }
		 }
		 while(counter != lastIndex);	 
	};
	
	NSList.prototype.__setMultiSelectedVars = function(index,add)
	{
		if(index === -1)
		{
			this.__selectedItems = [];	
			this.__selectedIndexes = [];	
		}
		else if(add)
		{
			var data = this.__getItemByIndex(index);
			this.__selectedItems.push(data);
			this.__selectedIndexes.push(index);
		}
		else
		{
			var isUnselected = false;
			for (var count= 0; count < this.__selectedIndexes.length ; count++)
	        {
	            if (this.__selectedIndexes[count] === index)
	            {
	                this.__selectedItems.splice(count,1);
	                this.__selectedIndexes.splice(count,1);
	                isUnselected = true;
	                break;
	            }
	        }
			return isUnselected;
		}
		
		return true;
	};
	
	NSList.prototype.__isRowSelected= function(index)
	{
	    if(index > -1)
	    {
	    	var item = this.__getItemByIndex(index);
	    	if(item)
	    	{
	    		return item[this.__fieldSelected];
	    	}
	    }   
	    return false;
	};
	
	/******************************************************Start of Context Menu*************************************************************/
	NSList.prototype.__initializeContextMenu = function()
	{
		//if(!this.__contextMenu)
		//{
			var contextMenuSetting = {parent:this.__listContainer,isContextMenu:true,createRunTime:true,sourceProvider:this.__getContextMenuDataProvider.bind(this),targetType:"LI"};
			if(this.__contextMenuSetting)
			{
				for(var key in this.__contextMenuSetting)
				{
					//grid setting should not be overriden by the users
					if(!contextMenuSetting[key])
					{
						contextMenuSetting[key] = this.__contextMenuSetting[key];
					}
				}
			}
			this.__contextMenu = new NSMenu(contextMenuSetting);
		//}
	};
	
	NSList.prototype.__getContextMenuDataProvider = function(listItem)
	{
		if(listItem)
		{
			listItem = this.util.findParent(listItem,"LI");
			if(listItem)
			{
				var index = this.__getIndexFromTarget(listItem);
				var item = this.__getItemByIndex(index);
				if(item && this.__contextMenuProvider) 
				{
					return this.__contextMenuProvider(item,index);
				}
			}
		}
		return null;
	};
	/******************************************************End of Context Menu*************************************************************/
	/******************************Custom Function *************************************/
	NSList.prototype.__getIndexFromTarget = function(target)
	{
		if(target)
		{
			return parseInt(target.getAttribute("ns-index"));
		}
		return -1;
	};
	
	NSList.prototype.__getListItemFromItem = function(item)
	{
		var listItem = null;
		if(item)
		{
			listItem = item[this.__fieldItem];
			var index = item[this.__fieldIndex];
			//below case is true if row reference has been removed due to virtual scroll 
			var listItemRawIndex = this.__getListItemRawIndex(listItem); 
			if(!listItem || listItemRawIndex === -1)
			{
				var arrListItem = this.__listContainer.querySelectorAll('[ns-index="' + index + '"]');
				if(arrListItem && arrListItem.length > 0)
				{
					listItem = arrListItem[0];
				}
			}
		}
		return listItem;
	};
	
	NSList.prototype.__getListItemByIndex = function(index)
	{
		if(index > -1)
	    {
	    	var item = this.__getItemByIndex(index);
	    	if(item)
	    	{
	    		return item[this.__fieldItem];
	    	}
	    }   
		return null;
	};
	
	NSList.prototype.__getListItemFromContainer = function(index)
	{
		if(this.__listContainer.children.length > index)
		{
			return this.__listContainer.children[index];
		}
		return null;
	};
	
	NSList.prototype.__getItemByIndex = function(indexToFind,source)
	{
		if(!source)
		{
			source = this.__objGrid.__getFlatSource();
		}
		if(source && source.length > 0)
		{
			for(var count = 0;count < source.length;count++)
			{
				var item = source[count];
				if(item && item[this.__fieldIndex] === indexToFind)
				{
					return item;
				}
			}
		}
		return null;
	};
	
	NSList.prototype.__getIndexByItem = function(itemToFind,source)
	{
		if(!source)
		{
			source = this.__objGrid.__getFlatSource();
		}
		if(itemToFind && source && source.length > 0)
		{
			for(var count = 0;count < source.length;count++)
			{
				var item = source[count];
				if(item && item[this.__fieldIndex] === itemToFind[this.__fieldIndex])
				{
					return item[this.__fieldIndex];
				}
			}
		}
		return -1;
	};
	
	NSList.prototype.__addItem = function(arrItem,atIndex)
	{
		var flatSource = this.__objGrid.__getFlatSource();
		if(this.util.isUndefined(atIndex) || atIndex === null)
		{
			atIndex = flatSource.length;
		}
		if(arrItem && arrItem.length > 0)
		{
			if(this.__listContainer && this.__listContainer.children && this.__listContainer.children.length > 0 && this.__listContainer.children.length < 3)
			{
				for(var count = 0;count < this.__listContainer.children.length;count++)
				{
					var listItem = this.__listContainer.children[count];
					if(listItem.hasAttribute("nsNoData"))
					{
						this.__listContainer.removeChild(listItem);
						break;
					}
				}
			}
			if(!this.__addRemoveRowCallInternal)
	   	 	{
				this.__objGrid.__setWrapperSource(arrItem,atIndex,-1,0,true);
	   	 	};
			var item = null;
			var length = arrItem.length;
			var index = -1;
			for(var count = 0;count < length;count++)
			{
				item = arrItem[count];
				index = atIndex + count;
				if(item)
				{
					this.__dataSource.splice(index, 0, item);
					this.__arrWrapper.splice(index, 0, item);
					this.__arrInternalSource.splice(index, 0, item);
				}
			}
			/*flatSource = this.__objGrid.__getFlatSource();
			this.__updateSourceIndex(flatSource);*/
			for(var count = 0;count < length;count++)
			{
				item = arrItem[count];
				if(this.__enableVirtualScroll)
				{
					
				}
				else
				{
					this.__createListAt(item,item[this.__fieldIndex]);
				}
			}
		}
	};
	
	NSList.prototype.__moveItem = function(arrItem,toIndex)
	{
		if(arrItem && arrItem.length > 0 && !this.util.isUndefined(toIndex) && toIndex !== null)
		{
			var item = null;
			var length = arrItem.length;
			var index = -1;
			var fromIndex = -1;
			var listContainer = this.__listContainer;
			var listItem = null;
			for(var count = length - 1;count >= 0;count--)
			{
				item = arrItem[count];
				index = toIndex + count;
				if(item)
				{
					fromIndex = item[this.__fieldIndex];
					this.util.moveArrayItem(this.__dataSource,fromIndex,index);
					this.util.moveArrayItem(this.__arrWrapper,fromIndex,index);
					this.util.moveArrayItem(this.__arrInternalSource,fromIndex,index);
					if(this.__enableVirtualScroll)
					{
						
					}
					else
					{
						// donot use item[this.__fieldItem] for getting listItem as after de-serialization the reference get lost 
						// hence getting the item back from dataSource
						item = this.__getItemByIndex(fromIndex);
						listItem = item[this.__fieldItem];
						if(listItem)
						{
							if(listItem.parentNode === listContainer)
							{
								listContainer.removeChild(listItem);
							}
							index = (index === 0) ? index : (index - 1);
							listContainer.insertBefore(listItem, listContainer.children[index]);
						}
					}
				}
			}
		}
	};
	
	NSList.prototype.__updateSourceIndex = function(source)
	{
		if(!source)
		{
			source = this.__getAllItems();
		}
		var item = null;
		var listItem = null;
		var length = source.length;
		for(var count = 0;count < length;count++)
		{
			item = source[count];
			var index = this.__enableHierarchical ? (count + 1) : count;
			item[this.__fieldIndex] = index;
			listItem = item[this.__fieldItem];
			if(listItem && this.util.isElementOfType(listItem,"li"))
			{
				listItem.setAttribute("ns-index",index);
				var compArrow = listItem.querySelector(".nsListArrow");
				if(compArrow)
				{
					compArrow.setAttribute("ns-parent-row-count",index);
					var arrowID = this.getID() + "compArrow" + index;
					compArrow.setAttribute("id",arrowID);
					var compSvg = compArrow.querySelector("svg");
					if(compSvg)
					{
						var svgID = arrowID + "svg";
						compSvg.setAttribute("id",svgID);
					}
					var compUse = compArrow.querySelector("use");
					if(compUse)
					{
						var useID = arrowID + "use";
						compUse.setAttribute("id",useID);
					}
				}
			}
		}
	};
	
	NSList.prototype.__createArrow = function(item,parentRowCount,parentElement,isCollapsed)
	{
		 if(parentElement)
		 {
			 var cellArrowParent = this.util.createDiv(null,"nsListArrowParent");
			 var arrowID = this.getID() + "compArrow" + parentRowCount;
			 var compArrow = this.util.createDiv(arrowID,"nsListArrow");
			 compArrow.style.paddingTop = "3px";
			 compArrow.setAttribute("ns-parent-row-count",parentRowCount);
			 
			 var objSVG = new NSSvg();
			 this.__objGrid.__createArrow(compArrow,objSVG,arrowID,isCollapsed);
			 this.util.addEvent(compArrow,"click",this.__arrowClickHandler.bind(this));
			 cellArrowParent.appendChild(compArrow);
			 parentElement.appendChild(cellArrowParent);
			 item[this.__fieldItemArrow] = compArrow;
			 return compArrow;
		 }
		 return null;
	};
	
	NSList.prototype.__setArrowDirection = function(compArrow,isCollapsed)
	{
		if(compArrow)
		{
			var objSVG = new NSSvg();
			var useID = compArrow.getAttribute("id") + "use";
			this.__objGrid.__setArrowDirection(objSVG,useID,isCollapsed);
		}
	};
	
	NSList.prototype.__isArrowCollapsed = function(compArrow)
	{
		if(compArrow && compArrow.hasAttribute("ns-parent-row-count"))
		{
			var rowIndex = parseInt(compArrow.getAttribute("ns-parent-row-count"));
			var item = this.__getItemByIndex(rowIndex);
			if(item)
			{
				return item[this.__fieldIsCollapsed];
			}
		}
		return false;
	};
	
	NSList.prototype.__arrowClickHandler = function(event)
	{
		event = this.util.getEvent(event);
		var target = this.util.getTarget(event);
		target = this.util.findParent(target,"DIV");
		if(target && target.hasAttribute("ns-parent-row-count"))
		{
			var rowIndex = target.getAttribute("ns-parent-row-count");
			var isCollapse = this.__isArrowCollapsed(target);
			rowIndex = parseInt(rowIndex);
			if(rowIndex > -1)
			{
				var item = this.__getItemByIndex(rowIndex);
				if(item[this.__childField]  && item[this.__childField].length > 0)
		        {
					this.__showHideRow(rowIndex,target,!isCollapse);
		        }
				else 
				{
					this.__objGrid.__handleOnDemandClick(item,event);
				}
			}
		}
		event.stopImmediatePropagation();
	};
	
	NSList.prototype.__expandCollapseAll = function(isCollapse)
	{
		if(!this.__enableVirtualScroll && this.__getTotalListItems() < this.__totalRecords)
		{
			this.util.warning("nsList","Please let all the items to render.");
			return;
		}
		var dataSource = this.__arrInternalSource;
		if(dataSource && dataSource.length > 0)
		{
			if(this.__enableVirtualScroll)
			{
				this.__expandCollapseAllVirtual(dataSource,isCollapse);
			}
			else
			{
				this.__expandCollapseAllNormal(dataSource,isCollapse);
			}
		}
	};
	
	NSList.prototype.__expandCollapseAllNormal = function(dataSource,isCollapse)
	{
		for(var count = 0;count < dataSource.length;count++)
		{
			var item = dataSource[count];
			//setting __fieldIsCollapsed here assuming that __showHideAllArrows() will be called after this function
			item[this.__fieldIsCollapsed] = isCollapse;
			if(parseInt(item[this.__fieldItemLevel]) > 0)
			{
				var row = item[this.__fieldItem];
				if(isCollapse)
				{
					row.style.display = "none";
					item[this.__fieldItemVisible] = false;
				}
				else
				{
					row.style.display = "";
					item[this.__fieldItemVisible] = true;
				}
			}
		}
		this.__showHideAllArrows(isCollapse);
	};
	
	NSList.prototype.__expandCollapseAllVirtual = function(dataSource,isCollapse)
	{
		for(var count = 0;count < dataSource.length;count++)
		{
			var item = dataSource[count];
			//setting __fieldIsCollapsed here assuming that __showHideAllArrows() will be called after this function
			item[this.__fieldIsCollapsed] = isCollapse;
			if(parseInt(item[this.__fieldItemLevel]) > 0)
			{
				if(isCollapse)
				{
					item[this.__fieldItemVisible] = false;
				}
				else
				{
					item[this.__fieldItemVisible] = true;
				}
			}
		}
		this.__showHideAllArrows(isCollapse);
		this.__updateVisibleIndex(null,0);
		this.__setNSVirtualScroll(this.__arrInternalSource);
	};
	
	NSList.prototype.__showHideRow = function(rowIndex,compArrow,isCollapse)
	{
		if(rowIndex > -1)
		{
			var item = this.__getItemByIndex(rowIndex);
			if(!compArrow)
			{
				compArrow = this.__getArrow(item[this.__fieldIndex]);
			}
			var rowLevel = parseInt(item[this.__fieldItemLevel]);
			var arrChildItems = [];
			if(item && item[this.__fieldHasChild])
			{
				var startIndex = 0;
				if(isCollapse)
				{
					arrChildItems = this.__arrInternalSource;
					startIndex = rowIndex;
				}
				else
				{
					arrChildItems = this.__getImmediateChildItems(arrChildItems, item);
				}
				if(this.__enableVirtualScroll)
				{
					this.__showHideRowVirtual(item,arrChildItems,startIndex,rowLevel,isCollapse);
					item[this.__fieldIsCollapsed] = isCollapse;
					//this.__updateItemInSource(item);
					this.__setNSVirtualScroll(this.__arrInternalSource);
				}
				else
				{
					this.__showHideRowNormal(item,arrChildItems,startIndex,rowLevel,isCollapse);
					this.__setArrowDirection(compArrow,isCollapse);
					item[this.__fieldIsCollapsed] = isCollapse;
				}
			}
		}
	};
	
	NSList.prototype.__showHideRowNormal = function(item,arrChildItems,startIndex,rowLevel,isCollapse)
	{
		if(arrChildItems && arrChildItems.length > 0)
		{
			if(isCollapse)
			{
				var retIndex = this.__getActualIndex(arrChildItems,startIndex);
				if(retIndex !== startIndex)
				{
					startIndex = (retIndex + 1);
				}
			}
			var rowItem = null;
			for(var count = startIndex;count < arrChildItems.length;count++)
			{
				rowItem = arrChildItems[count];
				var row = rowItem[this.__fieldItem];
				if(!row)
				{
					row = this.__createListAt(rowItem,rowItem[this.__fieldIndex] - 1,false);
					rowItem[this.__fieldItem] = row;
					this.__updateSourceIndex();
				}
				if(isCollapse)
				{
					if(rowLevel >= parseInt(rowItem[this.__fieldItemLevel]))
					{
						break;
					}
					row.style.display = "none";
					rowItem[this.__fieldItemVisible] = false;
					if(rowItem[this.__fieldHasChild])
					{
						rowItem[this.__fieldIsCollapsed] = true;
						if(rowItem[this.__fieldItemArrow])
						{
							var divArrow = rowItem[this.__fieldItemArrow];
							if(divArrow)
							{
								this.__setArrowDirection(divArrow,true);
							}
						}
					}
				}
				else
				{
					row.style.display = "";
					rowItem[this.__fieldItemVisible] = true;
				}
			}
		}
	};
	
	NSList.prototype.__showHideRowVirtual = function(item,arrChildItems,startIndex,rowLevel,isCollapse)
	{
		if(arrChildItems && arrChildItems.length > 0)
		{
			if(isCollapse)
			{
				var retIndex = this.__getActualIndex(arrChildItems,startIndex);
				if(retIndex !== startIndex)
				{
					startIndex = (retIndex + 1);
				}
			}
			for(var count = startIndex;count < arrChildItems.length;count++)
			{
				var rowItem = arrChildItems[count];
				if(isCollapse)
				{
					if(rowLevel >= parseInt(rowItem[this.__fieldItemLevel]))
					{
						break;
					}
					rowItem[this.__fieldItemVisible] = false;
					if(rowItem[this.__fieldHasChild])
					{
						rowItem[this.__fieldIsCollapsed] = true;
					}
				}
				else
				{
					rowItem[this.__fieldItemVisible] = true;
				}
			}
			var index = item[this.__fieldIndex];
			this.__updateVisibleIndex(null,index - 1);
		}
	};
	
	NSList.prototype.__showHideAllArrows = function(isCollapse)
	{
		var arrDivs = this.__getAllArrows();
		if(arrDivs && arrDivs.length > 0)
		{
			for(var count = 0;count < arrDivs.length;count++)
			{
				var div = arrDivs[count];
				if(div && div.hasAttribute("ns-parent-row-count"))
				{
					this.__setArrowDirection(div,isCollapse);
				}
			}
		}
	};
	
	NSList.prototype.__getAllItems = function()
	{
		return this.__objGrid.__getFlatSource();
	};
	
	NSList.prototype.__updateListItemText = function(listItem,item,index)
	{
		return this.__objGrid.__updateListItemText(listItem,item,index);
	};
	
	NSList.prototype.__getImmediateChildItems = function(arrItems,item)
	{
		if(!arrItems)
		{
			arrItems = [];
		}
		if(item && item[this.__fieldHasChild])
		{
			var arrChild = this.__arrInternalSource;
			var rowLevel = parseInt(item[this.__fieldItemLevel]);
			var startIndex = item[this.__fieldIndex];
			var retIndex = this.__getActualIndex(arrChild,startIndex);
			if(retIndex !== startIndex)
			{
				startIndex = (retIndex + 1);
			}
			var length = arrChild.length;
			for(var count = startIndex;count < length;count++)
			{
				var itemChild = arrChild[count];
				var childRowLevel = parseInt(itemChild[this.__fieldItemLevel]);
				if(rowLevel >= childRowLevel)
				{
					break;
				}
				if((rowLevel + 1) === childRowLevel)
				{
					arrItems.push(itemChild);
				}
			}
		}
		return arrItems;
	};
	
	//generally used for Filter condition
	NSList.prototype.__getActualIndex = function(arrChild,startIndex,addCompareOne)
	{
		//(startIndex + 1) as __fieldIndex starts from 1
		if(arrChild && arrChild.length < startIndex || arrChild[startIndex][this.__fieldIndex] !== (startIndex + 1))
		{
			var compareIndex = startIndex;
			if(addCompareOne)
			{
				compareIndex += 1;
			}
			var rowItem = null;
			for(var count = 0;count < arrChild.length;count++)
			{
				rowItem = arrChild[count];
				if(rowItem[this.__fieldIndex] === compareIndex)
				{
					return count;
				}
			}
		}
		return startIndex;
	};
	
	
	NSList.prototype.__getAllChildItems = function(arrItems,item)
	{
		if(!arrItems)
		{
			arrItems = [];
		}
		if(item && item[this.__fieldHasChild])
		{
			var arrChild = this.__arrInternalSource;
			var rowLevel = parseInt(item[this.__fieldItemLevel]);
			var startIndex = item[this.__fieldIndex];
			var length = arrChild.length;
			for(var count = startIndex;count < length;count++)
			{
				var itemChild = arrChild[count];
				if(rowLevel >= parseInt(itemChild[this.__fieldItemLevel]))
				{
					break;
				}
				arrItems.push(itemChild);
			}
		}
		return arrItems;
	};
	
	NSList.prototype.__getAllVisibleItems = function()
	{
		var totalRecords = 0;
		var arrItems = this.__getAllItems();
		if(arrItems && arrItems.length > 0)
		{
			for(var count = 0;count < arrItems.length;count++)
			{
				var item = arrItems[count];
				if(item && item[this.__fieldItemVisible])
				{
					totalRecords += 1;
				}
			}
		}
		return totalRecords;
	};
	
	NSList.prototype.__getFirstVisibleItemBeforeIndex = function(itemIndex)
	{
		var arrItems = this.__getAllItems();
		if(arrItems && arrItems.length > 0)
		{
			var retIndex = this.__getActualIndex(arrItems,itemIndex);
			if(retIndex !== itemIndex)
			{
				itemIndex = (retIndex + 1);
			}
			for(var count = itemIndex;count >= 0;count--)
			{
				var item = arrItems[count];
				if(item && item[this.__fieldItemVisible] && item[this.__fieldVisibleIndex] > -1)
				{
					return item;
				}
			}
		}
		return null;
	};
	
	NSList.prototype.__getVisibleItemByIndex = function(source,index)
	{
		var arrItems = source;
		if(!arrItems)
		{
			arrItems = this.__getAllItems();
		}
		if(arrItems && arrItems.length > 0)
		{
			var self = this; 
			var findItem = function(itemCompare)
			{
				 return (itemCompare[self.__fieldVisibleIndex] === (index + 1));
			};
			return arrItems.find(findItem);
		}
		return null;
	};
	
	NSList.prototype.__updateVisibleIndex = function(source,fromIndex)
	{
		var arrItems = source;
		if(!arrItems)
		{
			arrItems = this.__getAllItems();
		}
		if(this.util.isUndefinedOrNull(fromIndex))
		{
			fromIndex = 0;
		}
		if(arrItems && arrItems.length > 0)
		{
			var visibleRowIndex = 1;
			if(fromIndex > 0)
			{
				var visibleItem = this.__getFirstVisibleItemBeforeIndex(fromIndex);
				if(visibleItem)
				{
					visibleRowIndex = visibleItem[this.__fieldVisibleIndex];
					fromIndex = visibleItem[this.__fieldIndex] - 1;
					var retIndex = this.__getActualIndex(arrItems,fromIndex,true);
					if(retIndex !== fromIndex)
					{
						fromIndex = retIndex;
					}
				}
			}
			var length = arrItems.length;
			var item = null;
			for(var count = fromIndex; count < length; count++)
			{
				item = arrItems[count];
				if(item)
				{
					if(item[this.__fieldItemVisible])
					{
						item[this.__fieldVisibleIndex] = visibleRowIndex;
						visibleRowIndex++;
					}
					else
					{
						item[this.__fieldVisibleIndex] = -1;
					}
				}
			}
		}
	};
	
	NSList.prototype.__updateVisibleIndexByListItem = function(source,arrAllItems)
	{
		if(source)
		{
			var arrItems = arrAllItems;
			if(!arrItems)
			{
				arrItems = this.__getAllItems();
			}
			var length = source.length;
			var item = null;
			var objVisibleIndex = {};
			for(var count = 0; count < length; count++)
			{
				item = source[count];
				if(item)
				{
					var index = item[this.__fieldIndex];
					objVisibleIndex[index] = "NSList";
				}
			}
			if(arrItems && arrItems.length > 0)
			{
				length = arrItems.length;
				item = null;
				var visibleRowIndex = 1;
				for(var count = 0; count < length; count++)
				{
					item = arrItems[count];
					var index = item[this.__fieldIndex];
					if(this.util.isUndefinedOrNull(objVisibleIndex[index]))
					{
						item[this.__fieldVisibleIndex] = -1;
						item[this.__fieldItemVisible] = false;
					}
					else
					{
						item[this.__fieldVisibleIndex] = visibleRowIndex;
						item[this.__fieldItemVisible] = true;
						visibleRowIndex++;
					}
				}
			}
			
		}
	};
	
	NSList.prototype.__updateIndexForAllItems = function(source)
	{
		if(!source)
		{
			source = this.__getAllItems();
		}
		var length = source.length;
		var item = null;
		for(var count = 0; count < length; count++)
		{
			item = source[count];
			if(item)
			{
				item[this.__fieldIndex] = count;
			}
		}
	};
	
	NSList.prototype.__getArrow = function(rowCount)
	{
		var arrDivs = this.__getAllArrows();
		if(arrDivs && arrDivs.length > 0)
		{
			for(var count = 0;count < arrDivs.length;count++)
			{
				var div = arrDivs[count];
				if(div && div.hasAttribute("ns-parent-row-count"))
				{
					var rowParentCount = div.getAttribute("ns-parent-row-count");
					if(rowParentCount && rowParentCount == rowCount)
					{
						return div;
					}
				}
			}
		}
		return null;
	};
	
	NSList.prototype.__getAllArrows = function(divParent)
	{
		if(!divParent)
		{
			divParent = this.__listContainer;
		}
		return divParent.querySelectorAll(".nsListArrow");
	};
	
	NSList.prototype.__getTotalListItems = function()
	{
		if(this.__listContainer && this.__listContainer.children)
		{
			return this.__listContainer.children.length;
		}
		return 0;
	};
	
	NSList.prototype.__updateTotalRecords = function(totalCount)
	{
		if(this.util.isUndefined(totalCount) || totalCount === null)
		{
			totalCount = this.__arrInternalSource.length; 
		}
		this.__totalRecords = totalCount;
	};
	
	NSList.prototype.__getListItemRawIndex = function(listItem)
	{
		if(listItem && listItem.parentNode)
		{
			var index = [].slice.call(listItem.parentNode.children).indexOf(listItem);
			return index;
		}
		return -1;
	};
	
	NSList.prototype.__checkForVirtualMode = function()
	{
		if(this.__enableVirtualScroll)
		{
			if(this.__enablePagination)
			{
				this.__enableVirtualScroll = false;
			}
		}
	};
	
	NSList.prototype.__setVirtualScroll_ScrollTop = function(scrollTop)
	{
		if(this.__enableCustomScrollBar)
		{
			if(this.__scroller)
			{
				this.__scroller.setScrollTop(scrollTop);
			}
		}
	};
	
	var NSFlatList = function(nsList)
	{
		this.__nsList = nsList;
		this.util = nsList.util;
		/********************************Common Functions for Grid ****************************************/
		this.__initialize = function()
		{
		};
		
		this.dataSource = function(source)
		{
			this.__nsList.__arrWrapper = this.__nsList.__dataSource.slice(0);
			this.__setWrapperSource(this.__nsList.__arrWrapper,0,-1,0,true);
			this.__nsList.__arrInternalSource = this.__nsList.__arrWrapper.slice(0);
			this.__nsList.__updateTotalRecords();
		};
		
		this.addItemsAsChildren = function(item,arrChildren)
		{
		};
		
		this.__setWrapperSource = function(source,offset,parentIndex,level,setFieldIndex)
		{
			if(source)
			{
				if(!offset)
				{
					offset = 0;
				}
				var length = source.length;
				var count = 0;
				var item = null;
				var index = -1; 
				for (count = 0; count < length; count++) 
				{
					item = source[count];
					index = offset + count;
					this.__setItemProperty(item,index,setFieldIndex);
				}
			}
		};
	
		this.__createList= function(dataSet,startIndex,endIndex)
		{
			var item = null;
			var index = -1;
		    for(var count = startIndex; count < endIndex; count++)
		     {
	    		item = dataSet[count];
	    		index =  item[this.__nsList.__fieldIndex];
	    		this.__nsList.__updateItem(item,index);
	    		this.__nsList.__createListItem(item);
		     }
		};
		
		this.__createListItem = function(listItem,item)
		{
		};
	
		this.__addSVGInPage = function()
		{
		};
	
		this.__setListItemProperties = function(listItem,item)
		{
			if(listItem && item)
			{
				var index = item[this.__nsList.__fieldIndex];
				listItem.setAttribute("ns-index",index);
				item[this.__nsList.__fieldItem] = listItem;
				this.util.removeAllChildren(listItem);
				var divCell = this.util.createDiv(null,"nsListChild");
				this.util.addStyleClass(divCell,this.__nsList.__CLASS_CELL_CHILD);
				listItem.appendChild(divCell);
				this.__nsList.__addCellText(listItem,item,divCell);
			}
		};
		
		this.__updateListItemText = function(listItem,item,index)
		{
			if(listItem && item)
			{
				this.util.removeAllChildren(listItem);
				this.__setListItemProperties(listItem,item);
			}
		};
	
		this.__getFlatSource= function()
		{
			return this.__nsList.__arrWrapper;
		};
		/********************************Common Functions for Grid ****************************************/
		this.__setItemProperty = function(item,rowIndex,setFieldIndex)
		{
			if(item)
			{
				if(setFieldIndex)
				{
					item[this.__nsList.__fieldIndex] = rowIndex;
				}
				item[this.__nsList.__fieldVisibleIndex] = rowIndex + 1;
			}
		};
	
		this.__resetListItem = function(listItem,index,item)
		{
			listItem.style.display = "";
			listItem.setAttribute("ns-index",index);
			this.util.removeStyleClass(listItem,"nsListItemSelected");
			this.__nsList.__updateItem(item,index);
			this.__setListItemProperties(listItem,item);
		};
	};
	
	var NSHierarchicalList = function(nsList)
	{
		this.__nsList = nsList;
		this.util = nsList.util;
		this.__ARROW_COLLAPSE_PATH = "M 0 9.99994L 6.10352e-005 -3.05176e-005L 5 5.00006L 0 9.99994 Z";
		this.__ARROW_EXPANDED_PATH = "M 0 3.05176e-005L 9.99994 9.15527e-005L 4.99988 5.00003L 0 3.05176e-005 Z";
		this.__CLASS_ARROW = "nsListArrowFill";
		this.__rowCounter = -1;
		this.__enableOnDemandHierarchy = false;
		this.__onDemandChildDetectionField = "hasChildren";
		this.__onDemandChildFetchCallback = null;
		/********************************Common Functions for Grid ****************************************/
		this.__initialize = function()
		{
			var setting = this.__nsList.__setting;
			if(setting.hasOwnProperty("enableOnDemandHierarchy"))
			{
				this.__enableOnDemandHierarchy = Boolean.parse(setting["enableOnDemandHierarchy"]);
			}
			if(this.__enableOnDemandHierarchy)
			{
				if(setting.hasOwnProperty("onDemandChildDetectionField"))
				{
					this.__onDemandChildDetectionField = setting["onDemandChildDetectionField"];
				}
				if(setting.hasOwnProperty("onDemandChildFetchCallback"))
				{
					this.__onDemandChildFetchCallback = setting["onDemandChildFetchCallback"];
					this.__onDemandChildFetchCallback = this.util.getFunction(this.__onDemandChildFetchCallback);
				}
				if(!this.__onDemandChildDetectionField)
				{
					this.util.throwNSError("NSList","Value for onDemandChildDetectionField is not valid");
				}
				if(!this.__onDemandChildFetchCallback)
				{
					this.util.throwNSError("NSList","Value for onDemandChildFetchCallback is not valid");
				}
				if(this.__enableVirtualScroll)
				{
					this.util.warning("NSList","As enableVirtualScroll is true so OnDemandHierarchy will have no impact.");
				}
			}
		};
		
		this.dataSource = function(source)
		{
			this.__nsList.__arrWrapper = this.__nsList.__dataSource.slice(0);
			this.__setWrapperSource(this.__nsList.__arrWrapper,0,-1,0,true,true,true);
			this.__nsList.__updateTotalRecords(this.__rowCounter);
			this.__nsList.__arrInternalSource = this.__nsList.__arrFlatHierarchicalSource.slice(0);
		};
		
		this.addItemsAsChildren = function(item,arrChildren)
		{
			if(item && arrChildren && arrChildren.length > 0)
			{
				if(!item[this.__nsList.__childField])
				{
					item[this.__nsList.__childField] = [];
				}
				item[this.__nsList.__childField].push.apply(item[this.__nsList.__childField], arrChildren);
				this.__setWrapperSource(this.__nsList.__arrWrapper,0,-1,0,true,false,false);
				this.__nsList.__updateTotalRecords(this.__rowCounter);
				this.__nsList.__arrInternalSource = this.__nsList.__arrFlatHierarchicalSource.slice(0);
				item[this.__nsList.__fieldItemVisible] = true;
				item[this.__nsList.__fieldIsCollapsed] = false;
		   		var listItem = this.__nsList.__getListItemFromItem(item);
		   		var rowIndex = this.__nsList.__getIndexByItem(item);
		   		this.__nsList.__showHideRow(rowIndex,null,false);
		   		console.log(this.__nsList.__arrFlatHierarchicalSource);
			}
		};
		
		this.__setWrapperSource = function(source,offset,parentIndex,level,setFieldIndex,setIsCollapsed,setItemVisible)
		{
			if(source)
			{
				if(level === 0)
				{
					if(!offset)
					{
						offset = 0;
					}
					this.__nsList.__arrFlatHierarchicalSource = [];
					this.__rowCounter = offset;
				}
				var length = source.length;
				var count = 0;
				var item = null;
				for (count = 0; count < length; count++) 
				{
					item = source[count];
					this.__rowCounter++;
					this.__nsList.__arrFlatHierarchicalSource.push(item);
					this.__setItemProperty(item,parentIndex,level,setFieldIndex,setIsCollapsed,setItemVisible);
				}
			}
		};
	
		this.__createList= function(dataSet,startIndex,endIndex)
		{
			var item = null;
			var index = -1;
		    for(var count = startIndex; count < endIndex; count++)
		    {
	    		item = dataSet[count];
	    		if(item)
	    		{
	    			index =  item[this.__nsList.__fieldIndex];
	        		this.__nsList.__updateItem(item,index);
	        		this.__nsList.__createListItem(item);
	    		}
		    }
		};
		
		this.__createListItem = function(listItem,item)
		{
		};
	
		this.__addSVGInPage = function()
		{
			var objSVG = new NSSvg();
			objSVG.addPath("svgListArrowDown",this.__ARROW_EXPANDED_PATH,"0 0 16 16");
			objSVG.addPath("svgListArrowRight",this.__ARROW_COLLAPSE_PATH,"0 0 16 16");
		};
	
		this.__setListItemProperties = function(listItem,item)
		{
			if(listItem && item)
			{
				var index = item[this.__nsList.__fieldIndex];
				var level = item[this.__nsList.__fieldItemLevel];
				var parentIndex = item[this.__nsList.__fieldParentIndex];
				listItem.setAttribute("ns-index",index);
				listItem.setAttribute("ns-level",level);
				if(item[this.__nsList.__fieldHasParent])
			    {
					listItem.setAttribute("ns-parent-index",parentIndex);
			    }
				item[this.__nsList.__fieldItem] = listItem;
				this.util.removeAllChildren(listItem);
				var divCell = this.util.createDiv(null,"nsListChild");
				listItem.appendChild(divCell);
				
				var hierarchicalPadding = 0;
				var divText = null;
				if(item && item.hasOwnProperty(this.__nsList.__labelField) && item[this.__nsList.__labelField])
				{
			        if((item[this.__nsList.__childField]  && item[this.__nsList.__childField].length > 0) || (this.__isOnDemandHasChildren(item)))
			        {
			        	this.util.addStyleClass(divCell,this.__nsList.__CLASS_GROUP_CELL);
			        	this.__nsList.__createArrow(item,index,divCell,item[this.__nsList.__fieldIsCollapsed]);
			        	var cellText = this.util.createDiv(null,this.__nsList.__CLASS_CELL_CHILD);
			        	this.util.addStyleClass(cellText,"nsListGroupCellText");
			        	cellText.style.verticalAlign = "top";
			        	divText = cellText;
			        	divCell.appendChild(cellText);
			        }
			        else
			        {
			        	this.util.addStyleClass(divCell,this.__nsList.__CLASS_CELL_CHILD);
			        	divText = divCell;
			        	//24 = 16(Arrow Width) + 6(Arrow Parent Padding) + 2(divCell horizontalGap between elements shown in debugger)
			        	hierarchicalPadding = 24;
			        }
			        this.__nsList.__addCellText(listItem,item,divText);
		        	if(level === 0)
		        	{
		        		listItem.style.paddingLeft = "1px";
		        	}
		        	else
		        	{
		        		var paddingLeft = (10 * level) + hierarchicalPadding;
		        		listItem.style.paddingLeft = paddingLeft + "px";
		        	}
				}
			}
		};
		
		this.__updateListItemText = function(listItem,item,index)
		{
			if(listItem && item)
			{
				this.util.removeAllChildren(listItem);
				this.__setListItemProperties(listItem,item);
			}
		};
	
		this.__getFlatSource= function()
		{
			return this.__nsList.__arrFlatHierarchicalSource;
		};
		
		this.__handleOnDemandClick = function(item,event)
		{
			if(item && this.__isOnDemandHasChildren(item))
			{
				if(this.__onDemandChildFetchCallback)
				{
					event = this.util.getEvent(event);
					var rowLevel = item[this.__nsList.__fieldItemLevel];
					var rowIndex = this.__nsList.__getIndexByItem(item);
					this.__onDemandChildFetchCallback(item,rowIndex,rowLevel,event);
				}
			}
		};
		/********************************Common Functions for Grid ****************************************/
		this.__setItemProperty = function(item,parentIndex,level,setFieldIndex,setIsCollapsed,setItemVisible)
		{
			if(item)
			{
				if(this.util.isUndefinedOrNull(setIsCollapsed))
				{
					setIsCollapsed = true;
				}
				if(this.util.isUndefinedOrNull(setItemVisible))
				{
					setItemVisible = true;
				}
				var totalRowCount = this.__rowCounter;
				if(setFieldIndex || this.util.isUndefinedOrNull(item[this.__nsList.__fieldIndex]))
				{
					item[this.__nsList.__fieldIndex] = totalRowCount;
				}
				item[this.__nsList.__fieldVisibleIndex] = totalRowCount;
				item[this.__nsList.__fieldItemLevel] = level;
				var hasChild = false;
				if(item.hasOwnProperty(this.__nsList.__childField) && item[this.__nsList.__childField] && item[this.__nsList.__childField].length > 0)
			    {
			    	hasChild = true;
			    	this.__setWrapperSource(item[this.__nsList.__childField],0,totalRowCount,level + 1,setFieldIndex,setIsCollapsed,setItemVisible);
			    }
				item[this.__nsList.__fieldParentIndex] = parentIndex;
				if(parentIndex > -1)
			    {
					item[this.__nsList.__fieldHasParent] = true;
			    }
				else
				{
					item[this.__nsList.__fieldHasParent] = false;
				}
				item[this.__nsList.__fieldHasChild] = hasChild;
				if(setItemVisible || this.util.isUndefinedOrNull(item[this.__nsList.__fieldItemVisible]))
				{
					item[this.__nsList.__fieldItemVisible] = true;
				}
				if(setIsCollapsed || this.util.isUndefinedOrNull(item[this.__nsList.__fieldIsCollapsed]))
				{
					item[this.__nsList.__fieldIsCollapsed] = this.__isOnDemandHasChildren(item);
				}
			}
		};
		
		this.__createArrow = function(compArrow,objSVG,arrowID,isCollapsed)
		{
			 var svg = objSVG.addSVG(compArrow,arrowID + "svg",this.__CLASS_ARROW,null,null,null,null,null,null,true);
			 if(isCollapsed)
			 {
				 objSVG.addUse(svg,arrowID + "use",null,"#svgListArrowRight");
			 }
			 else
			 {
				 objSVG.addUse(svg,arrowID + "use",null,"#svgListArrowDown");
			 }
		};
	
		this.__setArrowDirection = function(objSVG,useID,isCollapsed)
		{
			if(isCollapsed)
			{
				objSVG.changeUseHref(useID,"#svgListArrowRight");
			}
			else
			{
				objSVG.changeUseHref(useID,"#svgListArrowDown");
			}
		};
	
		this.__resetListItem = function(listItem,index,item)
		{
			listItem.style.display = "";
			listItem.setAttribute("ns-index",index);
			this.util.removeStyleClass(listItem,"nsListItemSelected");
			this.__nsList.__updateItem(item,index);
			this.__setListItemProperties(listItem,item);
		};
		
		this.__isOnDemandHasChildren = function(item)
		{
			return (this.__enableOnDemandHierarchy && item[this.__onDemandChildDetectionField]);
		};
	};
	
	var NSListFilter = function(nsList)
	{
		this.__nsList = nsList;
		
		this.util = nsList.util;
		this.__filteredColumn = [];
		this.__config = {};
		this.__nsDragDrop = null;
		
		this.__initialize = function()
		{
			
		};
		
		this.filter = function(strData,filterSetting,enableHighlighting,recordLimit)
		{
			if(!filterSetting)
			{
				filterSetting = {};
			}
			if(this.util.isUndefinedOrNull(enableHighlighting))
			{
				enableHighlighting = true;
			}
			var config = {
					caseSensitive: this.util.isUndefinedOrNull(filterSetting["caseSensitive"]) ? false : Boolean.parse(filterSetting["caseSensitive"]),
					multiline: this.util.isUndefinedOrNull(filterSetting["multiline"]) ? false : Boolean.parse(filterSetting["multiline"]),
					matchType: filterSetting["matchType"] || new NSFilter().CONTAINS
			};
			var filter = {};
			var setting = {};
			var field = this.__nsList.__labelField;
			filter[field] = strData;
			setting[field] = {caseSensitive:config["caseSensitive"],multiline:config["multiline"],matchType:config["matchType"]};
			if(filter && Object.keys(filter).length > 0)
			{
				this.__handleFiltering(filter,setting,enableHighlighting,recordLimit);
			}
			else
			{
				this.__resetFiltering();
			}
		};
		
		this.reset = function()
		{
			this.__resetFiltering();
		};
		
		this.__handleFiltering = function(filter,setting,enableHighlighting,recordLimit)
		{
			this.__filteredColumn = [];
			if(filter)
		    {
				 var field = this.__nsList.__labelField;
				 var source = this.__nsList.__arrWrapper;
				 var isHierarchical = false;
				 if(this.__nsList.__enableHierarchical)
				 {
					 isHierarchical = true;
				 }
			   	 var nsFilter = new NSFilter(source,filter,setting,recordLimit,isHierarchical,this.__nsList.__childField);
			   	 this.__nsList.__arrInternalSource = nsFilter.execute();
			   	 if(enableHighlighting)
			   	 {
			   		for(var key in filter) 
		  	        {
		  	        	this.__filteredColumn.push({field:key,text:filter[key]});
		  	        }
			   	 }
			   	 if(isHierarchical)
			   	 {
			   		this.__nsList.__objGrid.__setWrapperSource(this.__nsList.__arrInternalSource,0,-1,0,false);
			   		this.__nsList.__arrInternalSource = this.__nsList.__arrFlatHierarchicalSource.slice(0); 
			   	 }
			   	 this.__nsList.__updateTotalRecords();
			   	 this.__nsList.__renderBody();
			   	 this.__nsList.__updateVisibleIndexByListItem(this.__nsList.__arrInternalSource);
		    }
		};
	
		this.__resetFiltering = function()
		{
			if(this.__nsList.__dataSource)
			{
				this.__nsList.__arrInternalSource = this.__nsList.__arrWrapper.slice(0);
				this.__filteredColumn = [];
				if(this.__nsList.__enableHierarchical)
				{
					this.__nsList.__objGrid.__setWrapperSource(this.__nsList.__arrInternalSource,0,-1,0,false);
					this.__nsList.__arrInternalSource = this.__nsList.__arrFlatHierarchicalSource.slice(0); 
				}
				this.__nsList.__updateTotalRecords();
				this.__nsList.__renderBody();
				this.__nsList.__updateVisibleIndexByListItem(this.__nsList.__arrInternalSource);
			}
		};
	
		this.__highlightDiv = function(divText)
		{
			var length = this.__filteredColumn.length;
			for (var count = 0; count < length; count++) 
		    {
				var text = this.__filteredColumn[count].text;
				this.util.highlightText(divText,text,"nsTextHighlight");
		    }
		};
		
		this.__initialize();
	};
	
	var NSListDragDrop = function(nsList)
	{
		this.__nsList = nsList;
		this.util = nsList.util;
		
		this.__disableDraggableFunction = null;
		this.__disableDropableFunction = null;
		
		this.initialize = function()
		{
			var container = this.__nsList.__listContainer;
			var setting = {container:container,childNodeType:"LI",isContainerDraggable:this.__nsList.__isDraggable,isContainerDroppable:this.__nsList.__isDroppable,
						   enableDragByHandle:this.__nsList.__enableDragByHandle,dragHandlerClass:this.__nsList.__dragHandlerClass,
						   enableDragAfterHold:this.__nsList.__enableDragAfterHold,enableCloneMode:this.__nsList.__enableCloneMode,holdTime:this.__nsList.__holdTime,createCloneCallback:this.__createClone.bind(this),
						   createPlaceholderCallback:this.__createPlaceholder.bind(this),nodeDroppableCallback:this.__isListItemDroppable.bind(this),
						   nodeDraggableCallback:this.__isListItemDraggable.bind(this),insertNodeCallback:this.__insertListItemHandler.bind(this),
						   moveNodeCallback:this.__moveListItemHandler.bind(this),removeNodeCallback:this.__removeListItemHandler.bind(this)};
			this.__nsDragDrop = new NSDragDrop(setting);
			this.util.addEvent(container,this.__nsDragDrop.ITEM_DROPPING,this.__itemDroppingHandler.bind(this));
			this.util.addEvent(container,this.__nsDragDrop.ITEM_DROPPED,this.__itemDroppedHandler.bind(this));
			this.util.addEvent(container,this.__nsDragDrop.DRAG_STARTING,this.__dragStartingHandler.bind(this));
			this.util.addEvent(container,this.__nsDragDrop.DRAG_STARTED,this.__dragStartHandler.bind(this));
			this.util.addEvent(container,this.__nsDragDrop.DRAGGING,this.__draggingHandler.bind(this));
			this.util.addEvent(container,this.__nsDragDrop.DRAG_END,this.__dragEndHandler.bind(this));
		};
		
		this.__initialize = function()
		{
			var setting = this.__nsList.__setting;
			if(setting.hasOwnProperty("disableDraggableFunction"))
			{
				this.__disableDraggableFunction = setting["disableDraggableFunction"];
				this.__disableDraggableFunction = this.util.getFunction(this.__disableDraggableFunction);
			}
			if(setting.hasOwnProperty("disableDropableFunction"))
			{
				this.__disableDropableFunction = setting["disableDropableFunction"];
				this.__disableDropableFunction = this.util.getFunction(this.__disableDropableFunction);
			}
		};
		
		this.__dragStartingHandler = function(event)
		{
			var listItem = event.node;
			var arrItems = this.__getSelectedItems(listItem);
			var data = {parentID:this.__nsList.__listContainer.getAttribute("id"),arrItems:arrItems};
			this.__nsDragDrop.setDragData(data);
		};
		
		this.__dragStartHandler = function(event)
		{
			var listItem = event.node;
			var data = this.__nsDragDrop.getDragData();
			var arrItems = data.arrItems;
			this.util.dispatchEvent(this.__nsList.__baseComponent,this.__nsList.DRAG_STARTED,arrItems,{items:arrItems});
		};
		
		this.__draggingHandler = function(event)
		{
			var listData = event.item;
			var data = this.__nsDragDrop.getDragData();
			var arrItems = data.arrItems;
			listData.arrItems = arrItems;
	 	    this.util.dispatchEvent(this.__nsList.__baseComponent,this.__nsList.DRAGGING,listData,{item:listData});
		};
		
		this.__dragEndHandler = function(event)
		{
			var data = this.__nsDragDrop.getDragData();
			var arrItems = data.arrItems;
	 	    this.util.dispatchEvent(this.__nsList.__baseComponent,this.__nsList.DRAG_END,arrItems,{items:arrItems});
		};
		
		this.__itemDroppingHandler = function(event)
		{
			var cancelled = this.util.dispatchEvent(this.__nsList.__baseComponent,this.__nsList.ITEM_DROPPING,event.item,{item:event.item},true,true);
			if(cancelled)
			{
				event.preventDefault();
			}
		};
		
		this.__itemDroppedHandler = function(event)
		{
			this.util.dispatchEvent(this.__nsList.__baseComponent,this.__nsList.ITEM_DROPPED,event.item,{item:event.item},true,false);
		};
		
		this.__createClone = function(listItem,containerConfiguration)
		{
			var listContainer = this.__nsList.__listContainer.cloneNode(false);
			var data = this.__nsDragDrop.getDragData();
			var arrItems = data.arrItems;
			var clonedNode = null;
			//make a clone only when clone Mode is ON or the list is not droppable
			if(this.__nsList.__enableCloneMode || !this.__nsList.__isDroppable)
			{
				for(var count = 0;count < arrItems.length;count++)
				{
					clonedNode = arrItems[count][this.__nsList.__fieldItem].cloneNode(true);
					clonedNode.setAttribute("id","comp" + listContainer.id + "ClonedNode" + count);
					listContainer.appendChild(clonedNode);
				}
			}
			else
			{
				for(var count = 0;count < arrItems.length;count++)
				{
					clonedNode = arrItems[count][this.__nsList.__fieldItem];
					listContainer.appendChild(clonedNode);
				}
			}
			listContainer.style.width = containerConfiguration.width + "px";
			return listContainer;
		};
		
		this.__createPlaceholder = function(listItem)
		{
			var listItem = this.util.createElement("li",null,"nsListEmptyItem");
			listItem.innerHTML = "<div class='nsListEmptyChild'>&nbsp;</div>";
			return listItem;
		};
		
		this.__isListItemDroppable = function(listItem)
		{
			var item = this.__getItemFromTarget(listItem);
			return this.__isItemDroppable(listItem,item);
		};
		
		this.__isListItemDraggable = function(listItem)
		{
			var item = this.__getItemFromTarget(listItem);
			return this.__isItemDraggable(listItem,item);
		};
		
		this.__insertListItemHandler = function(container,newListItem,index,currentListItem,data)
		{
			var arrItems = data.arrItems;
			this.__nsList.__addItem(arrItems,index);
		};
		
		this.__moveListItemHandler = function(container,newListItem,index,currentListItem,data)
		{
			var arrItems = data.arrItems;
			this.__nsList.__moveItem(arrItems,index);
		};
		
		this.__removeListItemHandler = function(container,listItem,data)
		{
			
		};
		
		this.__getSelectedItems = function(target)
		{
			var list = this.__nsList;
			var listContainer = list.__listContainer;
			var index = parseInt(list.__getIndexFromTarget(target));
			var item = list.__getItemByIndex(index);
			var arrItems = [];
			var arrSelectedItems = list.getSelectedItems();
			var itemSelected = false; 
			if(arrSelectedItems && arrSelectedItems.length > 0)
			{
				var tempItem = null;
				for(var count = 0;count < arrSelectedItems.length;count++)
				{
					tempItem = this.__cloneItem(arrSelectedItems[count]);
					if(tempItem[list.__fieldIndex] === item[list.__fieldIndex])
					{
						itemSelected = true;
					}
					arrItems.push(tempItem);
				}
			}
			if(!itemSelected || !arrItems || arrItems.length === 0 || !arrItems[0])
			{
				var tempItem = this.__cloneItem(item);
				arrItems = [tempItem];
			}
			return arrItems;
		};
		
		this.__cloneItem = function(item)
		{
			var list = this.__nsList;
			var tempItem = null;
			if(item)
			{
				tempItem = this.util.cloneObject(item);
				if(list.__enableHierarchical && tempItem[list.__childField] && tempItem[list.__childField].length > 0)
				{
					var arrChild = tempItem[list.__childField];
					var length = arrChild.length;
					var childItem = null;
					var tempChildItem = null;
					for(var count = 0;count < length;count++)
					{
						childItem = arrChild[count];
						tempChildItem = this.__cloneItem(childItem);
						if(tempChildItem)
						{
							tempItem[list.__childField][count] = tempChildItem;
						}
					}
				}
			}
			return tempItem;
		};
		
		this.__getItemFromTarget = function(listItem)
		{
			var itemIndex = this.__nsList.__getIndexFromTarget(listItem);
			return this.__nsList.__getItemByIndex(itemIndex);
		};
		
		this.__isItemDraggable = function(listItem,item) 
	    {
			var retValue = true;
			if(this.__disableDraggableFunction)
			{
				retValue = this.__disableDraggableFunction(item,this.__nsList.__labelField,item[this.__nsList.__fieldIndex],item[this.__nsList.__fieldDisableHover],listItem);
				retValue = !retValue;
			}
	    	return retValue;
		};
		
		this.__isItemDroppable = function(event) 
	    {
			var retValue = true;
			if(this.__disableDropableFunction)
			{
				var target = this.util.getTarget(event);
				target = this.util.findParent(target,"li");
				var index = this.__nsList.__getIndexFromTarget(target);
				var item = this.__nsList.__getItemByIndex(index);
				if(item)
				{
					retValue = this.__disableDropableFunction(item,this.__nsList.__labelField,item[this.__nsList.__fieldIndex],item[this.__nsList.__fieldDisableHover],target);
					retValue = !retValue;
				}
			}
	    	return retValue;
		};
		
		this.__initialize();
	};
	return NSList;
})();
nsModuleExport(this,"NSList",NSList);
"use strict";
var NSFilter = (function()
{
	function NSFilter(data,filter,setting,recordLimit,isHierarchical,childField,filterFunction,hierarchyFilterChildren,arrIgnoreKeysInCloneDataSource) 
	{
		this.EXACT = "exact";
		this.STARTS_WITH = "startsWith";
		this.ENDS_WITH = "endsWith";
		this.CONTAINS = "contains";
		
		this.IS_FOUND_FIELD = "__nsFilter__found";
		
		this.util = new NSUtil();
		this.__data = data;
		this.__filter = filter;
		this.__setting = setting;
		this.__recordLimit = (parseInt(recordLimit) > 0) ? recordLimit : -1;
		this.__isHierarchical = this.util.isUndefined(isHierarchical) ? false : Boolean.parse(isHierarchical);
		this.__childField = childField ? childField : "children";
		this.__filterFunction = filterFunction;
		this.__hierarchyFilterChildren = hierarchyFilterChildren;
		this.__arrIgnoreKeysInCloneDataSource = arrIgnoreKeysInCloneDataSource;
		this.__ignoreSameLevelNode = true;
	}
	
	NSFilter.prototype.execute = function(data,filter,setting,recordLimit,isHierarchical,childField,filterFunction,hierarchyFilterChildren,arrIgnoreKeysInCloneDataSource) 
	{ 
		data = data ? data : this.__data;
		filter = filter ? filter : this.__filter;
		setting = setting ? setting : this.__setting;
		recordLimit = (parseInt(recordLimit) > 0) ? recordLimit : this.__recordLimit;
		isHierarchical = this.util.isUndefined(isHierarchical) ? Boolean.parse(this.__isHierarchical) : Boolean.parse(isHierarchical);
		childField = childField ? childField : this.__childField;
		filterFunction = filterFunction ? filterFunction : this.__filterFunction;
		hierarchyFilterChildren = hierarchyFilterChildren ? hierarchyFilterChildren : this.__hierarchyFilterChildren;
		arrIgnoreKeysInCloneDataSource = this.util.isUndefinedOrNull(arrIgnoreKeysInCloneDataSource) ? this.__arrIgnoreKeysInCloneDataSource : arrIgnoreKeysInCloneDataSource;
		if(data && filter)
		{
			var dataSource = data.slice(0);
			var arrFilter = [];
			var self = this;
			var callFilterFunction = function(source,level,parentItem)
			{
				var arrReturn = [];
				for (var count = 0; count < source.length; count++) 
				{
					var item = source[count];
					var found = false;
					if(isHierarchical && item[childField] && item[childField].length > 0 )
					{
						var arrChild = callFilterFunction(item[childField],level + 1,item);
						if(arrChild && arrChild.length > 0)
						{
							found = true;
							if(self.__ignoreSameLevelNode)
							{
					            item[childField] = arrChild;
							}
							arrReturn.push(item);
						}
					}
					if(!found && self.__filterItem(item,filter,setting,isHierarchical,childField,parentItem,filterFunction))
					{
						if(isHierarchical && hierarchyFilterChildren)
						{
							var arrChildren = item[childField];
							if(arrChildren && arrChildren.length > 0)
							{
								var childItem = null;
								var childLength = arrChildren.length;
								for(var childCount = childLength - 1;childCount > -1;childCount--)
								{
									childItem = arrChildren[childCount];
									if(childItem)
									{
										if(!hierarchyFilterChildren(childItem,childCount,childItem[self.IS_FOUND_FIELD],filter,setting,item))
										{
											arrChildren.splice(childCount, 1);
										}
									}
								}
							}
						}
						found = true;
						arrReturn.push(item);
						if(!isHierarchical && recordLimit > 0 && arrReturn.length >= recordLimit)
						{
							break;
						}
					}
				}
				//return false;
				return arrReturn;
			};
			var callNonHierarchicalFilterFunction = function(source)
			{
				var arrReturn = [];
				for (var count = 0; count < source.length; count++) 
				{
					var item = source[count];
					if(self.__filterItemNonHierarchical(item,filter,setting,filterFunction))
					{
						arrReturn.push(item);
					}
				}
				return arrReturn;
			};
			dataSource = this.util.cloneObject(dataSource,isHierarchical,[],arrIgnoreKeysInCloneDataSource);
			if(isHierarchical)
			{
				arrFilter = callFilterFunction(dataSource,1,null);
			}
			else
			{
				arrFilter = callNonHierarchicalFilterFunction(dataSource);
			}
			return arrFilter;
		}
		return data;
	};
	
	NSFilter.prototype.__filterItemNonHierarchical = function(item,filter,setting,filterFunction) 
	{
		var retValue = false;
		if(filterFunction)
		{
			retValue = filterFunction(item,filter,setting);
			this.__setItem(item,retValue);
			return retValue;
		}
		else if(filter instanceof Function) 
	    {
			retValue = filter(item,setting);
	        this.__setItem(item,retValue);
	        return retValue;
	    }
	    else if(filter instanceof Array) 
	    {
	        for (var count = 0; count < filter.length; ++count) 
	        {
	            if (this.__filterItemNonHierarchical(item,filter[count],setting,filterFunction))
	            {
	            	this.__setItem(item,true);
	            	return true;
	            }
	        }
	        return false;
	    }
	    else if(setting.type === "date" && filter)
	    {
	        return this.__filterDate(item,filter,setting);
	    }
	    else if(typeof(item) === "string" && filter)
	    {
	        return this.__filterString(item,filter,setting);
	    }
	    else if (item === item + 0 && filter)
	    {
	        return this.__filterNumeric(item,filter);
	    }
	    else if(typeof (filter) === "object") 
	    {
	        for(var key in filter) 
	        {
	        	var tempSetting = {};
	        	if(setting && setting[key])
	        	{
	        		tempSetting = setting[key];
	        	}
	            if(!this.__filterItemNonHierarchical(item[key],filter[key],tempSetting,filterFunction))
	            {
	            	return false;
	            }
	        }
	        this.__setItem(item,true);
	        return true;
	    }
		retValue = (filter == item);
	    this.__setItem(item,retValue);
	    return retValue;
	};
	
	NSFilter.prototype.__filterItem = function(item,filter,setting,isHierarchical,childField,parentItem,filterFunction) 
	{
		var retValue = false;
		if(filterFunction)
		{
			retValue = filterFunction(item,filter,setting,isHierarchical,childField,parentItem);
			this.__setItem(item,retValue);
			return retValue;
		}
		else if(filter instanceof Function) 
	    {
			retValue = filter(item,setting);
	        this.__setItem(item,retValue);
	        return retValue;
	    }
	    else if(filter instanceof Array) 
	    {
	        for (var count = 0; count < filter.length; ++count) 
	        {
	            if (this.__filterItem(item,filter[count],setting,isHierarchical,childField,parentItem,filterFunction))
	            {
	            	this.__setItem(item,true);
	            	return true;
	            }
	        }
	        return false;
	    }
	    else if(setting.type === "date" && filter)
	    {
	        return this.__filterDate(item,filter,setting);
	    }
	    else if(typeof(item) === "string" && filter)
	    {
	        return this.__filterString(item,filter,setting);
	    }
	    else if (item === item + 0 && filter)
	    {
	        return this.__filterNumeric(item,filter);
	    }
	    else if(typeof (filter) === "object") 
	    {
	        for(var key in filter) 
	        {
	        	if(isHierarchical && key === childField)
	        	{
	        		continue;
	        	}
	        	var tempSetting = {};
	        	if(setting && setting[key])
	        	{
	        		tempSetting = setting[key];
	        	}
	            if(!this.__filterItem(item[key],filter[key],tempSetting,isHierarchical,childField,parentItem,filterFunction))
	            {
	            	return false;
	            }
	        }
	        this.__setItem(item,true);
	        return true;
	    }
		retValue = (filter == item);
	    this.__setItem(item,retValue);
	    return retValue;
	};
	
	NSFilter.prototype.__setItem = function(item,isFound)
	{
		if(item && typeof (item) === "object" && isFound)
		{
			item[this.IS_FOUND_FIELD] = true;
		}
	};
	
	NSFilter.prototype.__filterNumeric= function(value,searchParam)
	{
		var retValue = false;
		value = parseFloat(value);
		if(!isNaN(value))
		{
			if(/<=/.test(searchParam)) // first checks if there is an operator (<,>,<=,>=)
			{
				retValue = (value <= parseFloat(searchParam.replace(/<=/,"")));
			}
			else if(/>=/.test(searchParam))
			{
				retValue = (value >= parseFloat(searchParam.replace(/>=/,"")));
			}
			else if(/</.test(searchParam))
			{
				retValue = (value < parseFloat(searchParam.replace(/</,"")));
			}
			else if(/>/.test(searchParam))
			{
				retValue = (value > parseFloat(searchParam.replace(/>/,"")));
			}
			else
			{
				retValue = (value === parseFloat(searchParam));
			}
		}
		return retValue;
	};
	
	NSFilter.prototype.__filterDate= function(value,searchParam,setting)
	{
		var retValue = false;
		var self = this;
		var matchValue = function(compareValue,opt)
		{
			var compValue = false;
			if(self.util.isUndefinedOrNull(value))
			{
				compValue = false;
			}
			else
			{
				var newVal = self.__getDate(value,setting.cellFormat);
				if(newVal)
				{
					newVal.setHours(0, 0, 0, 0);
					compareValue.setHours(0, 0, 0, 0);
					switch(opt)
					{
						case "equals":
							if (compareValue.getTime() === newVal.getTime()) 
							{
								compValue = true;
				            }
						break;
						case "greaterThan":
							if (compareValue.getTime() < newVal.getTime()) 
							{
								compValue = true;
				            }
						break;
						case "lessThan":
							if (compareValue.getTime() > newVal.getTime()) 
							{
								compValue = true;
				            }
						break;
						case "notEqual":
							if (compareValue.getTime() != newVal.getTime()) 
							{
								compValue = true;
				            }
						break;
					}
				}
				else
				{
					self.util.warning("NSFilter",value + " cannot be converted to date Object for given cell format");
					compValue = false;
				}
			}
			return compValue;
		};
		var processDate = function(date,type)
		{
			var compValue = false;
			if(date && matchType1)
			{
				if(!date || !Object.prototype.toString.call(date) === '[object Date]')
				{
					compValue = true;
				}
				else if(setting.comparator)
				{
					compValue = setting.comparator(value,date,setting);
				}
				else
				{
					compValue = matchValue(date,type);
				}
			}
			return compValue;
		};
		if(setting.matchType1 || setting.matchType2)
		{
			var matchType1 = setting.matchType1;
			var firstDate = setting.firstDate;
			var operation = setting.operation;
			var matchType2 = setting.matchType2;
			var secondDate = setting.secondDate;
			if(this.util.isUndefinedOrNull(value))
			{
				retValue = false;
			}
			else if(firstDate && secondDate && matchType1 && matchType2 && operation)
			{
				var firstVal = processDate(firstDate,matchType1);
				var secondVal = processDate(secondDate,matchType2);
				switch(operation)
				{
					case "and":
						retValue = (firstVal && secondVal);
					break;
					case "or":
						retValue = (firstVal || secondVal);
					break;
				}
			}
			else if(firstDate && matchType1)
			{
				retValue = processDate(firstDate,matchType1);
			}
			else if(secondDate && matchType2)
			{
				retValue = processDate(secondDate,matchType2);
			}
			else
			{
				retValue = true;
			}
		}
		else
		{
			if(!searchParam || !Object.prototype.toString.call(searchParam) === '[object Date]')
			{
				retValue = true;
			}
			else if(setting.comparator)
			{
				retValue = setting.comparator(value,searchParam,setting);
			}
			else if(this.util.isUndefinedOrNull(value))
			{
				retValue = false;
			}
			else
			{
				retValue = matchValue(searchParam,"equals");
			}
		}
		return retValue;
	};
	
	NSFilter.prototype.__filterString= function(value,searchParam,setting)
	{
		var regExp = null;
		var regExpModifier = "g";
		var startWithChar = "(^)";
		var endsWithChar = "($)";
		var searchString = "";
		var isCaseSensitive = false;
		var isMultiline = false;
		var matchType = this.CONTAINS;
		if(setting)
		{
			isCaseSensitive = Boolean.parse(setting["caseSensitive"]);
			isMultiline = Boolean.parse(setting["multiline"]);
			matchType = setting["matchType"] ? setting["matchType"] : matchType;
		}
		if(!isCaseSensitive)
		{
			regExpModifier += "i";
		}
		if(isMultiline)
		{
			regExpModifier += "m";
		}
		searchParam = this.__removeSpecialCharacter(searchParam);
		if(matchType === this.EXACT)
		{
			searchString = startWithChar + searchParam + endsWithChar;
		}
		else if(matchType === this.STARTS_WITH)
		{
			searchString = startWithChar + searchParam;
		}
		else if(matchType === this.ENDS_WITH)
		{
			searchString = searchParam + endsWithChar;
		}
		else 
		{
			searchString = searchParam;
		}
		regExp = new RegExp(searchString,regExpModifier);
		return regExp.test(value);
	};
	
	NSFilter.prototype.__removeSpecialCharacter = function(text)
	{
		function replaceEscape(char)
		{
			if(text)
			{
				var exp = new RegExp("\\" + char,"g");
				text = text.replace(exp,"\\" + char);
			}
		}
		var specialChar = ['\\','[','^','$','.','|','?','*','+','(',')'];
		for(var count = 0;count < specialChar.length;count++) 
		{
			replaceEscape(specialChar[count]);
		}
		return text;
	};
	
	//ref from : https://stackoverflow.com/questions/7445328/check-if-a-string-is-a-date-value
	NSFilter.prototype.__getDate = function(value,arrFormat) 
	{
		if(value)
		{
			var dateFormat;
		    if (Object.prototype.toString.call(value) === '[object Date]') 
		    {
		        return value;
		    }
		    if(arrFormat)
		    {
		    	var dateUtil = new NSDateUtil();
		    	if(!this.util.isArray(arrFormat))
		    	{
		    		arrFormat = [arrFormat];
		    	}
		    	for(var count = 0;count < arrFormat.length;count++)
		    	{
		    		var format = arrFormat[count];
		    		var date = dateUtil.parseString(value,format);
		    		if(date)
		    		{
		    			return date;
		    		}
		    	}
		    }
		    else
		    {
		    	if (typeof value.replace === 'function') 
			    {
			        value.replace(/^\s+|\s+$/gm, '');
			    }
			    dateFormat = /(^\d{1,4}[\.|\\/|-]\d{1,2}[\.|\\/|-]\d{1,4})(\s*(?:0?[1-9]:[0-5]|1(?=[012])\d:[0-5])\d\s*[ap]m)?$/;
			    if(dateFormat.test(value))
			    {
			    	return new Date(value);//Date.parse(value);
			    }
		    }
		}
	    return null;
	};
	
	return NSFilter;
})();
nsModuleExport(this,"NSFilter",NSFilter);var NSTextBox = (function()
{
	function NSTextBox(component,setting) 
	{
		this.__setting = setting;
		this.__outerContainer = null;
		this.__textBox = null;
		this.__list = null;
		this.__nsList = null;
		this.__nsGrid = null;
		this.__renderer =  null;
		this.__itemRenderer = null;
		
		this.__context = window;
		this.__dataSource = null;
		this.__type = "text";
		this.__enableAutoComplete = false;
		this.__dropDownType = NSTextBox.DROPDOWN_TYPE_LIST;
		this.__minChars = -1;
		this.__maxChars = -1;
		this.__minSearchStartChars = 1;
		this.__caseSensitive = true;
		this.__required = false;
		this.__placeholder = null;
		this.__displayAsPassword = false;
		this.__enableServerSide = false;
		this.__enableServerWithSmartSearch = false;
		this.__delay = 150;
		this.__listWidth = -1;
		this.__maxListHeight = 300;
		this.__noRecordsFoundMessage = "No Records Found";
		//can be [a-zA-Z0-9,-]
		this.__restrict = null;
		this.__pattern = null;
		this.__styleClass = null;
		this.__dropDownSetting = null;
		this.__serverSearchCallback = null;
		this.__textBoxRendererCallback = null;
		/* arrGridSearchField used when type = "autocomplete" and dropDownType = NSTextBox.DROPDOWN_TYPE_GRID */
		this.__arrGridSearchField = null;
		this.__isGridOrFilter = false;
		
		this.__labelField = "label";
		this.__stopHoveringField = "stopHover";
		this.__labelFunction = null;
		this.__templateID = null;
		this.__setDataCallBack = null;
		this.__enableKeyboardNavigation = false;
		this.__enableMultipleSelection = false;
		this.__multiSelectionSeparator = ";";
		this.__filterSetting = {};
		this.__enableHighlighting = false;
		this.__searchRecordLimit = -1;
		//temp merging Manish's code
		this.__splitSearchType = null;
		
		this.__selectedItem = null;
		this.__selectedItems = [];	
		this.__timerInstance = null;
		this.__isFromItemSelected = false;
		this.__isFromCloseIcon = false;
		this.__isFromSearchTextSever = false;
		this.__lastNavigatedItem = {};
		this.__lastSearchParam = "";
		
		
		this.__keyPressedRef = null;
		this.__pasteRef = null;
		this.__documentClickRef = null;
		this.__documentKeyUpRef = null;
		this.__documentKeyDownRef = null;
		
		this.base.__setBaseComponent.call(this,component);
	};
	nsExtendPrototype(NSContainerBase,NSTextBox);
	NSTextBox.prototype.constructor = NSTextBox;
	
	NSTextBox.prototype.initializeComponent = function() 
	{
		this.base.initializeComponent.call(this);
		this.__setSetting();
	};
	
	NSTextBox.prototype.setComponentProperties = function() 
	{
		this.base.setComponentProperties.call(this);
		this.__createComponents();
		this.__setTextBoxProperty();
		if(this.__dataSource)
		{
			this.dataSource(this.__dataSource);
		}
	};
	
	NSTextBox.prototype.propertyChange = function(attrName, oldVal, newVal, setProperty)
	{
		var attributeName = attrName.toLowerCase();
		var callTextProperty = false;
		if(attributeName === "maxchars")
		{
			this.__maxChars =  parseInt(newVal);
			callTextProperty = true;
		}
		if(attributeName === "minchars")
		{
			this.__minChars =  parseInt(newVal);
		}
		if(attributeName === "minsearchstartchars")
		{
			this.__minSearchStartChars =  parseInt(newVal);
		}
		if(attributeName === "casesensitive")
		{
			this.__caseSensitive = Boolean.parse(newVal);
		}
		if(attributeName === "required")
		{
			this.__required = Boolean.parse(newVal);
			callTextProperty = true;
		}
		if(attributeName === "placeholder")
		{
			this.__placeholder = newVal;
			callTextProperty = true;
		}
		if(attributeName === "delay")
		{
			this.__delay =  parseInt(newVal);
		}
		if(attributeName === "maxlistheight")
		{
			this.__maxListHeight =  parseInt(newVal);
		}
		if(attributeName === "listwidth")
		{
			this.__listWidth =  parseInt(newVal);
		}
		if(attributeName === "labelfield")
		{
			this.__labelField = newVal;
		}
		if(attributeName === "labelfunction")
		{
			this.__labelFunction = newVal;
		}
		if(attributeName === "enablemultipleselection")
		{
			this.__enableMultipleSelection =  Boolean.parse(newVal);
		}
		if(attributeName === "enablekeyboardnavigation")
		{
			this.__enableKeyboardNavigation =  Boolean.parse(newVal);
		}
		if(attributeName === "norecordsfoundmessage")
		{
			this.__noRecordsFoundMessage = newVal;
		}
		if(attributeName === "multiselectionseparator")
		{
			this.__multiSelectionSeparator = newVal;
		}
		if(attributeName === "pattern")
		{
			this.__pattern = newVal;
			callTextProperty = true;
		}
		if(attributeName === "restrict")
		{
			this.__restrict = newVal;
			if(this.util.isValueNull(this.__restrict))
			{
				this.__restrict = null;
			}
			/*else
			{
				this.__restrict = "[" + this.__restrict + "]";
			}*/
			callTextProperty = true;
		}
		if(attributeName === "styleclass")
		{
			this.__styleClass = newVal;
			callTextProperty = true;
		}
		if(attributeName === "filtersetting")
		{
			this.__filterSetting =  newVal;
		}
		if(attributeName === "enablehighlighting")
		{
			this.__enableHighlighting =  Boolean.parse(newVal);
		}
		if(attributeName === "searchrecordlimit")
		{
			this.__searchRecordLimit =  parseInt(newVal);
		}
		if(attributeName === "splitsearchtype")
		{
			this.__splitSearchType =  newVal;
		}
		if(callTextProperty)
		{
			this.__setTextBoxProperty();
		}
		this.base.propertyChange.call(this,attrName, oldVal, newVal, setProperty);
	};
	
	NSTextBox.prototype.dataSource = function(dataSource)
	{
		this.__dataSource = dataSource;
		if(this.__enableAutoComplete)
		{
			this.__setListDataSource(this.__dataSource);
			if(this.__isFromSearchTextSever)
			{
				this.__isFromSearchTextSever = false;
				this.__searchText(this.__getSearchText(this.__textBox.value),true);
				this.__showHideList(true);
			}
			if(!this.__documentClickRef)
			{
				this.__documentClickRef = this.__documentClickHandler.bind(this);
				this.util.addEvent(document,"click",this.__documentClickRef);
			}
			if(this.__enableMultipleSelection)
			{
				if(!this.__documentKeyUpRef)
				{
					this.__documentKeyUpRef = this.__documentKeyUpHandler.bind(this);
					this.util.addEvent(document.body,"keyup",this.__documentKeyUpRef);
				}
				if(!this.__documentKeyDownRef)
				{
					this.__documentKeyDownRef = this.__documentKeyDownHandler.bind(this);
					this.util.addEvent(document.body,"keydown",this.__documentKeyDownRef);
				}
			}
		}
	};
	
	NSTextBox.prototype.componentResized = function(event) 
	{
		this.__updateListPos();
		this.base.componentResized(event);
	};
	
	NSTextBox.prototype.removeComponent = function() 
	{
		if(this.__documentClickRef)
		{
			this.util.removeEvent(document,"click",this.__documentClickRef);
			this.__documentClickRef = null;
		}
		if(this.__documentKeyUpRef)
		{
			this.util.removeEvent(document.body,"keyup",this.__documentKeyUpRef);
			this.__documentKeyUpRef = null;
		}
		if(this.__keyDownRef)
		{
			this.util.removeEvent(document.body,"keydown",this.__documentKeyDownRef);
			this.__documentKeyDownRef = null;
		}
		var control = this.__getNSControl();
		if(control && control.removeComponent)
		{
			control.removeComponent.call(control);
		}
		this.base.removeComponent.call(this);
	};
	
	NSTextBox.prototype.getTextBox = function()
	{
		return this.__textBox;
	};
	
	NSTextBox.prototype.setText = function(text)
	{
		if(this.__textBox)
		{
			if(text && this.__maxChars > -1 && text.length > this.__maxChars)
			{
				text = text.substring(0, this.__maxChars);
			}
			this.__textBox.value = text;
		}
	};
	
	NSTextBox.prototype.getText = function()
	{
		if(this.__textBox)
		{
			return this.__textBox.value;
		}
		return null;
	};
	
	NSTextBox.prototype.setSelectedItems = function(arrItems)
	{
		if(this.__getNSControl())
		{
			this.__getNSControl().setSelectedItems(arrItems);
		}
		//this.setText();
	};
	
	NSTextBox.prototype.setSelectedItem = function(item)
	{
		if(this.__getNSControl())
		{
			this.__getNSControl().setSelectedItem(item);
		}
		//this.setText();
	};
	
	NSTextBox.prototype.setSelectedIndexes = function(arrSelectedIndex)
	{
		if(this.__getNSControl())
		{
			this.__getNSControl().setSelectedIndexes(arrSelectedIndex);
		}
		//this.setText();
	};
	
	NSTextBox.prototype.setSelectedIndex = function(selectedIndex)
	{
		if(this.__getNSControl())
		{
			this.__getNSControl().setSelectedIndex(selectedIndex);
		}
		//this.setText();
	};
	
	NSTextBox.prototype.unSelectItems = function(arrItems)
	{
		if(this.__getNSControl())
		{
			this.__getNSControl().unSelectItems(arrItems);
		}
		//this.setText();
	};
	
	NSTextBox.prototype.unSelectItem = function(item)
	{
		if(this.__getNSControl())
		{
			this.__getNSControl().unSelectItem(item);
		}
		//this.setText();
	};
	
	NSTextBox.prototype.unSelectIndexes = function(arrSelectedIndex)
	{
		if(this.__getNSControl())
		{
			this.__getNSControl().unSelectIndexes(arrSelectedIndex);
		}
		//this.setText();
	};
	
	NSTextBox.prototype.unSelectIndex = function(selectedIndex)
	{
		if(this.__getNSControl())
		{
			this.__getNSControl().unSelectIndexes(selectedIndex);
		}
		//this.setText();
	};
	
	NSTextBox.prototype.unSelectAll = function(fireEvent)
	{
		/*if(this.__getNSControl())
		{
			this.__getNSControl().unSelectIndexes(selectedIndex);
		}*/
		this.setText(null);
		if(fireEvent)
		{
			this.__itemUnSelectHandler();
		}
	};
	
	//IMPORTANT:: not exposing getSelectedIndex and getSelectedIndexes as it will be relative to filtered dataSource
	NSTextBox.prototype.getSelectedItem = function()
	{
		return this.__selectedItem;
	};
	
	NSTextBox.prototype.getSelectedItems = function()
	{
		if(this.__getNSControl())
		{
			return this.__getNSControl().getSelectedItems();
		}
		return this.__selectedItems;
	};
	
	NSTextBox.prototype.__setSetting = function()
	{
		var setting = this.__setting;
		if(setting)
		{
			if(setting.hasOwnProperty("type"))
			{
				this.__type = setting["type"];
			}
			if(setting.hasOwnProperty("context"))
			{
				this.__context = setting["context"];
			}
			if(setting.hasOwnProperty("dropDownType"))
			{
				this.__dropDownType = setting["dropDownType"];
			}
			if(setting.hasOwnProperty("maxChars"))
			{
				this.__maxChars = parseInt(setting["maxChars"]);
			}
			if(setting.hasOwnProperty("minChars"))
			{
				this.__minChars = parseInt(setting["minChars"]);
			}
			if(setting.hasOwnProperty("minSearchStartChars"))
			{
				this.__minSearchStartChars = parseInt(setting["minSearchStartChars"]);
			}
			if(setting.hasOwnProperty("caseSensitive"))
			{
				this.__caseSensitive = Boolean.parse(setting["caseSensitive"]);
			}
			if(setting.hasOwnProperty("required"))
			{
				this.__required = Boolean.parse(setting["required"]);
			}
			if(setting.hasOwnProperty("placeholder"))
			{
				this.__placeholder = setting["placeholder"];
			}
			if(setting.hasOwnProperty("displayAsPassword"))
			{
				this.__displayAsPassword = Boolean.parse(setting["displayAsPassword"]);
			}
			if(setting.hasOwnProperty("enableServerSide"))
			{
				this.__enableServerSide = Boolean.parse(setting["enableServerSide"]);
			}
			if(setting.hasOwnProperty("enableServerWithSmartSearch"))
			{
				this.__enableServerWithSmartSearch = Boolean.parse(setting["enableServerWithSmartSearch"]);
			}
			if(setting.hasOwnProperty("serverSearchCallback"))
			{
				this.__serverSearchCallback = setting["serverSearchCallback"];
				if (typeof this.__serverSearchCallback === "string" || this.__serverSearchCallback instanceof String)
				{
					if(this.util.isFunction(this.__serverSearchCallback))
					{
						this.__serverSearchCallback = this.__context[this.__serverSearchCallback];
					}
				}
			}
			if(setting.hasOwnProperty("textBoxRendererCallback"))
			{
				this.__textBoxRendererCallback = setting["textBoxRendererCallback"];
				if (typeof this.__textBoxRendererCallback === "string" || this.__textBoxRendererCallback instanceof String)
				{
					if(this.util.isFunction(this.__textBoxRendererCallback))
					{
						this.__textBoxRendererCallback = this.__context[this.__textBoxRendererCallback];
					}
				}
			}
			if(setting.hasOwnProperty("delay"))
			{
				this.__delay =  parseInt(setting["delay"]);
			}
			if(setting.hasOwnProperty("maxListHeight"))
			{
				this.__maxListHeight =  parseInt(setting["maxListHeight"]);
			}
			if(setting.hasOwnProperty("listWidth"))
			{
				this.__listWidth =  parseInt(setting["listWidth"]);
			}
			if(setting.hasOwnProperty("labelField"))
			{
				this.__labelField = setting["labelField"];
			}
			if(setting.hasOwnProperty("arrGridSearchField"))
			{
				this.__arrGridSearchField = setting["arrGridSearchField"];
			}
			if(setting.hasOwnProperty("isGridOrFilter"))
			{
				this.__isGridOrFilter = setting["isGridOrFilter"];
			}
			if(setting.hasOwnProperty("stopHoveringField"))
			{
				this.__stopHoveringField = setting["stopHoveringField"];
			}
			if(setting.hasOwnProperty("labelFunction"))
			{
				this.__labelFunction = setting["labelFunction"];
			}
			if(setting.hasOwnProperty("template"))
			{
				this.__templateID = setting["template"];
			}
			if(setting.hasOwnProperty("setDataCallBack"))
			{
				this.__setDataCallBack = setting["setDataCallBack"];
			}
			if(setting.hasOwnProperty("itemRenderer"))
			{
				this.__itemRenderer = setting["itemRenderer"];
				if (typeof this.__itemRenderer === "string" || this.__itemRenderer instanceof String)
				{
					if(this.util.isFunction(this.__itemRenderer))
					{
						this.__itemRenderer = this.__context[this.__itemRenderer];
					}
				}
			}
			if(setting.hasOwnProperty("enableMultipleSelection"))
			{
				this.__enableMultipleSelection =  Boolean.parse(setting["enableMultipleSelection"]);
			}
			if(setting.hasOwnProperty("enableKeyboardNavigation"))
			{
				this.__enableKeyboardNavigation =  Boolean.parse(setting["enableKeyboardNavigation"]);
			}
			if(setting.hasOwnProperty("noRecordsFoundMessage"))
			{
				this.__noRecordsFoundMessage =  setting["noRecordsFoundMessage"];
			}
			if(setting.hasOwnProperty("multiSelectionSeparator"))
			{
				this.__multiSelectionSeparator =  setting["multiSelectionSeparator"];
			}
			if(setting.hasOwnProperty("pattern"))
			{
				this.__pattern =  setting["pattern"];
			}
			if(setting.hasOwnProperty("restrict"))
			{
				this.__restrict =  setting["restrict"];
				if(this.__restrict)
				{
					//this.__restrict = "[" + this.__restrict + "]";
				}
			}
			if(setting.hasOwnProperty("dataSource"))
			{
				this.__dataSource = setting["dataSource"];
			}
			if(setting.hasOwnProperty("styleClass"))
			{
				this.__styleClass = setting["styleClass"];
			}
			if(setting.hasOwnProperty("dropDownSetting"))
			{
				this.__dropDownSetting = setting["dropDownSetting"];
			}
			if(setting.hasOwnProperty("filterSetting"))
			{
				this.__filterSetting = setting["filterSetting"];
			}
			if(setting.hasOwnProperty("enableHighlighting"))
			{
				this.__enableHighlighting = Boolean.parse(setting["enableHighlighting"]);
			}
			if(setting.hasOwnProperty("searchRecordLimit"))
			{
				this.__searchRecordLimit = parseInt(setting["searchRecordLimit"]);
			}
			if(setting.hasOwnProperty("splitSearchType"))
			{
				this.__splitSearchType =  setting["splitSearchType"];
			}
		}
	};
	
	NSTextBox.prototype.__createComponents = function() 
	{
		if(!this.__outerContainer)
		{
			this.__applyTipToCoreComp = true;
			this.__outerContainer = this.util.createDiv(this.getID() + "#container","nsTextBoxContainer");
			this.addChild(this.__outerContainer);
			this.__textBox = this.util.createElement("INPUT",this.getID()+ "#textBox","nsTextBox");
			this.__textBox.setAttribute("type", this.__getType());
			this.util.addEvent(this.__textBox,"blur",this.__textBoxFocusOutHandler.bind(this));
			this.util.addEvent(this.__textBox,"focus",this.__focusInHandler.bind(this));
			//this.util.addEvent(this.__textBox,"search",this.__searchHandler.bind(this));
			if(this.__enableAutoComplete)
			{
				this.util.addStyleClass(this.__outerContainer,"nsTextBoxContainerAutoComplete");
				this.util.addStyleClass(this.__textBox,"nsTextBoxAutoComplete");
				this.__textBox.setAttribute("autocomplete","off");
				if(this.__enableMultipleSelection)
				{
					this.util.addEvent(this.__textBox,"keyup",this.__keyUpMultiSelectionHandler.bind(this));
					this.util.addEvent(this.__textBox,"keydown",this.__keyDownMultiSelectionHandler.bind(this));
					this.util.addStyleClass(this.__outerContainer,"nsTextBoxMultiSelectContainer");
					this.util.addEvent(this.__outerContainer,"click",this.__outerContainerClickHandler.bind(this));
					this.util.addStyleClass(this.__textBox,"nsTextBoxMultiSelect");
				}
				else
				{
					this.util.addEvent(this.__textBox,"keyup",this.__keyUpHandler.bind(this));
					this.util.addEvent(this.__textBox,"keydown",this.__keyDownHandler.bind(this));
				}
			}
			this.__outerContainer.appendChild(this.__textBox);
			this.__createList();
		}
	};
	
	NSTextBox.prototype.__getType = function()
	{
		var textBoxType = "text";
		if(this.__type)
		{
			if(this.__type ===  NSTextBox.TYPE_AUTOCOMPLETE)
			{
				textBoxType = "search";
				this.__enableAutoComplete = true;
			}
			else if(this.__displayAsPassword)
			{
				textBoxType = "password";
			}
			else if(this.__type ===  NSTextBox.TYPE_AUTOTEXT || this.__type ===  NSTextBox.TYPE_EMAIL || this.__type ===  NSTextBox.TYPE_NUMBER || this.__type ===  NSTextBox.TYPE_PASSWORD || this.__type ===  NSTextBox.TYPE_URL)
			{
				textBoxType = this.__type;
			}
		}
		return textBoxType;
	};
	
	
	NSTextBox.prototype.__setTextBoxProperty = function() 
	{
		if(this.__textBox)
		{
			if(this.__required)
			{
				this.__textBox.setAttribute("required", "");
			}
			else
			{
				this.__textBox.removeAttribute("required");   
			}
			if(this.__placeholder && this.__placeholder.length > 0 && !this.__enableMultipleSelection)
			{
				this.__textBox.setAttribute("placeholder", this.__placeholder);
			}
			else
			{
				this.__textBox.removeAttribute("placeholder");
			}
			if(this.__maxChars > -1)
			{
				this.__textBox.setAttribute("maxLength", this.__maxChars);
			}
			if(this.__pattern)
			{
				this.__textBox.setAttribute("pattern", this.__pattern);
			}
			else
			{
				this.__textBox.removeAttribute("pattern");
			}
			if(this.__styleClass)
			{
				this.__setStyleClass(this.__styleClass);
			}
			if(this.__restrict)
			{
				if(!this.__keyPressedRef)
				{
					this.__keyPressedRef = this.__keyPressHandler.bind(this);
					this.util.addEvent(this.__textBox,"keypress",this.__keyPressedRef);
				}
				if(!this.__pasteRef)
				{
					this.__pasteRef = this.__pasteHandler.bind(this);
					this.util.addEvent(this.__textBox,"paste",this.__pasteRef);
				}
			}
			else
			{
				if(this.__keyPressedRef)
				{
					this.util.removeEvent(this.__textBox,"keypress",this.__keyPressedRef);
					this.__keyPressedRef = null;
				}
				if(this.__pasteRef)
				{
					this.util.removeEvent(this.__textBox,"paste",this.__pasteRef);
					this.__pasteRef = null;
				}
			}
		}
		var genericEventHandler = this.__genericTextBoxEvent.bind(this);
		this.util.addEvent(this.__textBox,"change",genericEventHandler);
		this.util.addEvent(this.__textBox,"input",this.__searchHandler.bind(this));
	};
	
	NSTextBox.prototype.__setStyleClass = function(cssClass)
	{
		if(cssClass && cssClass.length > 0)
		{
			this.__textBox.setAttribute("class","");
			this.util.addStyleClass(this.__textBox,cssClass);
		}
	};
	
	NSTextBox.prototype.__outerContainerClickHandler = function(event)
	{
		event = this.util.getEvent(event);
		this.__textBox.focus();
	};
	
	NSTextBox.prototype.__documentKeyUpHandler = function(event)
	{
		event = this.util.getEvent(event);
		var keyCode = this.util.getKeyUnicode(event);
		if(this.__isFocusOnControl() && this.__enableMultipleSelection && (keyCode == this.util.KEYCODE.SHIFT || keyCode == this.util.KEYCODE.CTRL))
		{
			this.__multiSelectHandler();
			this.__hideList();
		}
	};
	
	NSTextBox.prototype.__documentKeyDownHandler = function(event)
	{
		event = this.util.getEvent(event);
		var keyCode = this.util.getKeyUnicode(event);
		if(this.__isFocusOnControl() && this.__enableMultipleSelection && (keyCode == this.util.KEYCODE.BACKSPACE))
		{
			 var arrSelectedItems = this.getSelectedItems();
			 if(arrSelectedItems && arrSelectedItems.length > 0) 
			 {
				 arrSelectedItems.pop();
				 if(this.__getNSControl())
				 {
					 this.setSelectedItems(arrSelectedItems);
				 }
				 this.__selectedItems = arrSelectedItems;
				 this.__refreshMultiSelectTags();
	         }
		}
	};
	
	NSTextBox.prototype.__keyUpHandler = function(event)
	{
		if(this.__isFocusOnControl())
		{
			event = this.util.getEvent(event);
			var keyCode = this.util.getKeyUnicode(event);
			if (keyCode == this.util.KEYCODE.ESC) 
			{
				this.__hideList();
			}
			else if (!(keyCode == this.util.KEYCODE.UP || keyCode == this.util.KEYCODE.DOWN || keyCode == this.util.KEYCODE.ENTER || keyCode == this.util.KEYCODE.SHIFT || keyCode == this.util.KEYCODE.CTRL)) 
			{
				this.__itemUnSelectHandler(event);
				if(!this.__textBox.value || this.__textBox.value == "" || this.__textBox.value.length < this.__minSearchStartChars)
				{
					this.__hideList();
				}
				else
				{
					if(this.__timerInstance)
					{
						clearTimeout(this.__timerInstance);
					}
					var compRef = this;
					this.__timerInstance = setTimeout(
					function()
					{ 
						compRef.__searchText(compRef.__getSearchText(compRef.__textBox.value));
					},this.__delay);
				}
			}
			else if (keyCode == this.util.KEYCODE.UP || keyCode == this.util.KEYCODE.DOWN)
			{
				var nsControl = this.__getNSControl();
				if(nsControl && !nsControl.hasFocus())
				{
					nsControl.setFocus(true);
					nsControl.__setRowHover(0);
					this.__lastNavigatedItem = (nsControl.__arrInternalSource && nsControl.__arrInternalSource.length > 0) ? nsControl.__arrInternalSource[0] : null;
				}
			}
			else
			{
				event.preventDefault();
			}
		}
	};
	
	NSTextBox.prototype.__keyDownHandler = function(event)
	{
		if(this.__isFocusOnControl())
		{
			event = this.util.getEvent(event);
			var keyCode = this.util.getKeyUnicode(event);
			if(keyCode == this.util.KEYCODE.TAB)
			{
				if(this.__lastNavigatedItem)
				{
					this.__itemSelectHandler(null,this.__lastNavigatedItem);
					this.__lastNavigatedItem = null;
				}
			}
		}
	};
	
	NSTextBox.prototype.__keyUpMultiSelectionHandler = function(event)
	{
		if(this.__isFocusOnControl())
		{
			event = this.util.getEvent(event);
			var keyCode = this.util.getKeyUnicode(event);
			//if backspace is pressed then return
			if(keyCode == this.util.KEYCODE.BACKSPACE)
			{
				return;
			}
			if (keyCode == this.util.KEYCODE.ESC) 
			{
				this.__hideList();
			}
			else if(keyCode == this.util.KEYCODE.SHIFT || keyCode == this.util.KEYCODE.CTRL)
			{
				this.__multiSelectHandler();
				this.__hideList();
			}
			
			//key Up
			/*if(keyCode === this.util.KEYCODE.UP && isShiftCtrlPressed && this.__enableMultipleSelection)
			{
			}
			//key down
			else if(keyCode === this.util.KEYCODE.DOWN && isShiftCtrlPressed && this.__enableMultipleSelection)
			{
			}*/
			else if (!(keyCode == this.util.KEYCODE.UP || keyCode == this.util.KEYCODE.DOWN || keyCode == this.util.KEYCODE.ENTER || keyCode == this.util.KEYCODE.SHIFT || keyCode == this.util.KEYCODE.CTRL)) 
			{
				if(!this.__textBox.value || this.__textBox.value == "" || this.__textBox.value.length < this.__minSearchStartChars)
				{
					this.__hideList();
				}
				else
				{
					if(this.__timerInstance)
					{
						clearTimeout(this.__timerInstance);
					}
					var compRef = this;
					this.__timerInstance = setTimeout(
					function()
					{ 
						compRef.__searchText(compRef.__getSearchText(compRef.__textBox.value));
					},this.__delay);
				}
			}
			else
			{
				event.preventDefault();
			}
		}
	};
	
	NSTextBox.prototype.__keyDownMultiSelectionHandler = function(event)
	{
		event = this.util.getEvent(event);
		var currentWidth = this.__textBox.offsetWidth;
		var width = this.__measureString(this.__textBox,this.__textBox.value + event.key) + 4;
		if (width !== currentWidth) 
		{
			this.__textBox.style.width = width + "px";
			this.__updateListPos();
		}
	};
	
	NSTextBox.prototype.__keyPressHandler = function(event)
	{
		if(this.__isFocusOnControl())
		{
			event = this.util.getEvent(event);
			var keyCode = this.util.getKeyUnicode(event);
			var keyPressed = String.fromCharCode(keyCode);
			if(!this.util.checkRegexValue(this.__restrict,keyPressed))
			{
				event.preventDefault();
			}
		}
	};
	
	NSTextBox.prototype.__genericTextBoxEvent = function(event,fireForcefully)
	{
		if(this.__isFocusOnControl() || fireForcefully)
		{
			event = this.util.getEvent(event);
			var cancelled = this.util.dispatchEvent(this.__baseComponent,event.type,this.getText(),{changeEvent:event},null,true);
			if(cancelled)
			{
				event.preventDefault();
			}
		}
	};
	
	NSTextBox.prototype.__documentClickHandler = function(event)
	{
		var closeList = true;
		var target = this.util.getTarget(event);
		if(target && target === this.__textBox)
		{
			closeList = false;
		}
		else
		{
			var targetList = this.util.findParentBySelector(target,".nsTextBoxList");
			if(targetList)
			{
				closeList = false;
			}
		}
		if(closeList)
		{
			this.__hideList();
			this.util.dispatchEvent(this.__baseComponent,NSTextBox.LIST_CLOSED_WITHOUT_SELECTION,this.getText(),{changeEvent:event});
		}
	};
	
	NSTextBox.prototype.__pasteHandler = function(event)
	{
		event = this.util.getEvent(event);
		var pastedText = undefined;
		var text = "";
		if (this.__context.clipboardData && this.__context.clipboardData.getData) 
		{ // IE
		    pastedText = this.__context.clipboardData.getData("Text");
		} 
		else if (event.clipboardData && event.clipboardData.getData) 
		{
		    pastedText = event.clipboardData.getData("text/plain");
		}
		var pastedTextLength = pastedText.length;
		for (var count = 0; count < pastedTextLength; count++) 
		{
			var char = pastedText.charAt(count);
	        if(this.util.checkRegexValue(this.__restrict,char))
	    	{
	        	text += char;
	    	}
	    }
		this.__textBox.value += text;
		event.preventDefault();
	};
	
	NSTextBox.prototype.__focusInHandler = function(event)
	{
		if(this.nsTip)
		{
			this.nsTip.remove();
		}
		if(this.__enableAutoComplete)
		{
			if(this.__textBox.value.length >= this.__minSearchStartChars && this.__dataSource && this.__dataSource.length > 0 && !this.__isFromItemSelected && !this.__isFromCloseIcon)
			{
				this.__setListDataSource(this.__dataSource);
				if(this.__textBox.value.length > 0)
				{
					this.__searchText(this.__getSearchText(this.__textBox.value));
				}
				this.__showHideList(true);
			}
			this.__isFromItemSelected = false;
			this.__isFromCloseIcon = false;
		}
	};
	
	NSTextBox.prototype.__textBoxFocusOutHandler = function(event)
	{
		if(this.__minChars > -1 && this.__textBox.value && this.__textBox.value.length < this.__minChars)
		{
			this.__textBox.setCustomValidity("Please enter atleast " + this.__minChars  + " characters.");
		}
		else 
		{
			this.__textBox.setCustomValidity("");
		}
	};
	
	NSTextBox.prototype.__searchHandler = function(event)
	{
		//the above code is for cross icon clicked when we enter any character
		//it might result in ITEM_UNSELECTED event called multiple times
		if(this.__enableAutoComplete && this.getSelectedItem() && this.__textBox.value == "")
		{
			this.unSelectAll(true);
		}
		this.__genericTextBoxEvent(event,true);
	};
	
	NSTextBox.prototype.__searchText = function(searchString,callClientSearch)
	{
		if(!callClientSearch && this.__isServerSideCall(searchString))
		{
			if(this.__lastSearchParam.toLowerCase() !== searchString.substr(0,this.__minSearchStartChars).toLowerCase())
			{
				if(this.__serverSearchCallback && this.util.isFunction(this.__serverSearchCallback))
				{
					this.__isFromSearchTextSever = true;
					var sendString = searchString;
					if(this.__enableServerWithSmartSearch)
					{
						this.__lastSearchParam = searchString.substr(0,this.__minSearchStartChars);
						sendString = this.__lastSearchParam;
					}
					this.__serverSearchCallback(sendString,this.__filterSetting,this.__enableHighlighting,this.__searchRecordLimit);
				}
				else
				{
					this.util.throwNSError("NSTextBox","ServerSearchCallback attribute doesnot have a valid value");
				}
			}
		}
		else if(this.__dataSource && this.__dataSource.length > 0)
		{
			if(searchString === "")
			{
				//should not have been done like this but grid has method resetFilters and List has resetFilter
				var nsControl = this.__getNSControl();
				var resetFilter = nsControl["resetFilter"] ? nsControl["resetFilter"] : nsControl["resetFilters"];
				resetFilter();
			}
			else
			{
				var control = this.__getNSControl();
				if(this.__isAutoCompleteTypeList())
				{
					control.filter(searchString,this.__filterSetting,this.__enableHighlighting,this.__searchRecordLimit);
				}
				else
				{
					var arrFilterField = this.__arrGridSearchField;
					if(!arrFilterField || arrFilterField.length === 0)
					{
						arrFilterField = [this.__labelField];
					}
					if(this.__isGridOrFilter)
					{
						 var filter = [];
						 var setting = {};
						 for(var count = 0;count < arrFilterField.length;count++)
						 {
							 var field = arrFilterField[count];
							 if(field)
							 {
								 var item = {};
								 item[field] = searchString;
								 setting[field] = this.__filterSetting;
								 filter.push(item);
							 }
						 }
					}
					else
					{
						var filter = {};
						var setting = {};
						for(var count = 0;count < arrFilterField.length;count++)
						{
							var field = arrFilterField[count];
							if(field)
							{
								filter[field] = searchString;
								setting[field] = this.__filterSetting;
							}
						}
					}
					control.filter(filter,setting,this.__enableHighlighting,this.__searchRecordLimit);
				}
			}
			this.__showHideList(true);
		}
	};
	
	NSTextBox.prototype.__isServerSideCall = function(searchString)
	{
		if(this.__enableServerWithSmartSearch)
		{
			var isSearchLength = ((searchString.length === this.__minSearchStartChars) || (searchString.length > this.__minSearchStartChars));
			var isContainsTempSearch = (!this.__dataSource || this.__dataSource.length == 0) || (this.__lastSearchParam.toLowerCase() !== searchString.substr(0,this.__minSearchStartChars).toLowerCase());
			return (isSearchLength && isContainsTempSearch);
		}
		return this.__enableServerSide;
		
	};
	
	NSTextBox.prototype.__createList = function()
	{
		if(!this.__list)
		{
			this.__list = this.util.createDiv(this.getID() + "list","nsTextBoxList");
			this.__list.style.height = this.__maxListHeight + "px";
			this.__outerContainer.appendChild(this.__list);
			if(this.__isAutoCompleteTypeList())
			{
				if(!this.__nsList)
				{
					if(!this.__dropDownSetting)
					{
						this.__dropDownSetting = {};
					}
					var overrideSetting = {labelField:this.__labelField,enableDragDrop:false,enableDragByHandle:false,
							   	   enableMultipleSelection:this.__enableMultipleSelection,enableKeyboardNavigation:this.__enableKeyboardNavigation,
							   	   enableMouseHover:true,enableMouseHoverAnimation:false,disableHoverField:this.__stopHoveringField};
					if(this.__templateID)
					{
						overrideSetting["template"] = this.__templateID;
						overrideSetting["setData"] = this.__setDataCallBack;
					}
					else
					{
						overrideSetting["itemRenderer"] = this.__itemRenderer;
					}
					var setting =  this.util.cloneObject(this.__dropDownSetting);
					for(var key in overrideSetting)
					{
						setting[key] = overrideSetting[key];
					}
					this.__nsList = new NSList(this.__list,setting);
					//this.__updateListPos();
					this.util.addEvent(this.__list,this.__nsList.ITEM_NAVIGATED,this.__itemNavigationHandler.bind(this));
					this.util.addEvent(this.__list,this.__nsList.ITEM_SELECTED,this.__itemSelectHandler.bind(this));
					this.util.addEvent(this.__list,this.__nsList.ITEM_UNSELECTED,this.__itemUnSelectHandler.bind(this));
				}
			}
			else
			{
				if(!this.__nsGrid)
				{
					if(!this.__dropDownSetting)
					{
						this.__dropDownSetting = {};
					}
					var overrideSetting = {type:"",enableMouseHover:true,enableFilter:true,enableAdvancedFilter:false,enablePagination:false, 
					          				columnResizable:false,columnDraggable:false,leftFixedColumn:0,rightFixedColumn:0,
					          				enableRowMove:false,enableContextMenu:false,enableExport:false,enableResponsive:false,
					          				theme:"White",enableCellSelection:false,enableRowSelection:true,enableDragDrop:false,
					          				enableDragByHandle:false,enableMultipleSelection:this.__enableMultipleSelection,
					          				enableKeyboardNavigation:this.__enableKeyboardNavigation,disableHoverField:this.__stopHoveringField,
					          				isPopUp:true};
					/*if(this.__templateID)
					{
						overrideSetting["template"] = this.__templateID;
						overrideSetting["setData"] = this.__setDataCallBack;
					}
					else
					{
						overrideSetting["itemRenderer"] = this.__itemRenderer;
					}*/
					var setting =  this.util.cloneObject(this.__dropDownSetting);
					for(var key in overrideSetting)
					{
						setting[key] = overrideSetting[key];
					}
					for(var count = 0;count < setting["columns"].length;count++)
					{
						var column = setting["columns"][count];
						column["enableFilter"] = false;
					}
					this.__nsGrid = new NSGrid(this.__list,setting);
					this.__nsGrid.setColumn(setting["columns"]);
					//this.__nsGrid.dataSource(arrItems);
					this.util.addEvent(this.__list,NSGrid.ROW_NAVIGATED,this.__itemNavigationHandler.bind(this));
					this.util.addEvent(this.__list,NSGrid.ROW_SELECTED,this.__itemSelectHandler.bind(this));
					this.util.addEvent(this.__list,NSGrid.ROW_UNSELECTED,this.__itemUnSelectHandler.bind(this));
				}
			}
			this.__hideList();
		}
	};
	
	NSTextBox.prototype.__setListDataSource = function(dataSource)
	{
		if(this.__getNSControl())
		{
			var source = this.util.cloneObject(dataSource);
			this.__getNSControl().dataSource(source);
		}
	};
	
	NSTextBox.prototype.__updateListPos = function()
	{
		if(this.__list)
		{
			/*var offset = {left:0,top:1};
            var rect = this.__outerContainer.getBoundingClientRect();
            this.__list.style.left = Math.round(rect.left + (window.pageXOffset || document.documentElement.scrollLeft) + offset.left) + 'px';
            this.__list.style.top = Math.round(rect.bottom + (window.pageYOffset || document.documentElement.scrollTop) + offset.top) + 'px';*/
            if(this.__listWidth > 0)
			{
				this.__list.style.width = this.__listWidth + "px";
			}
			else
			{
				this.__list.style.width = Math.round(rect.right - rect.left) + 'px'; // outerWidth
			}
		}
	};
	
	NSTextBox.prototype.__hideList = function()
	{
		this.__showHideList(false);
	};
	
	NSTextBox.prototype.__showHideList = function(isShow)
	{
		if(this.__list)
		{
			this.__list.style.visibility = isShow ? "" : "hidden";
			//this.__list.style.display = isShow ? "" : "none";
			if(isShow)
			{
				this.__updateListPos();
				var control = this.__getNSControl();
				if(control && control.reRender)
				{
					setTimeout(function(){
						control.reRender.call(control);
					},10);
				}
			}
			else
			{
				this.__getNSControl().setFocus(false);
			}
		}
	};
	
	NSTextBox.prototype.__isListVisible = function()
	{
		if(this.__list)
		{
			return !(this.__list.style.visibility == "hidden");
		}
		return false;
	};
	
	NSTextBox.prototype.__itemNavigationHandler = function(event)
	{
		if(event && event.detail)
		{
			this.__lastNavigatedItem = event.detail;
			if(!this.__enableMultipleSelection)
			{
				//this.__textBox.value = this.__lastNavigatedItem[this.__labelField];
			}
		}
	};
	
	NSTextBox.prototype.__itemSelectHandler = function(event,item)
	{
		var selectedItem = item ? item : ((event && event.detail) ? event.detail : null);
		if(selectedItem)
		{
			 selectedItem = this.__getNSControl().getOrignalItem(selectedItem);
			//console.log(this.__nsList.getSelectedItems());
			this.__selectedItem = selectedItem;
			if(this.__enableMultipleSelection)
			{
				this.__refreshMultiSelectTags();
			}
			else
			{
				this.__textBox.value = this.__getItemText(this.__selectedItem);
				this.__isFromItemSelected = true;
				this.__hideList();
			}
			event ? event.stopPropagation() : null;
			var index = event ? event.index : null;
			this.util.dispatchEvent(this.__baseComponent,NSTextBox.ITEM_SELECTED,selectedItem,{index:index});
		}
	};
	
	NSTextBox.prototype.__itemUnSelectHandler = function(event)
	{
		if(this.__enableMultipleSelection)
		{
			this.__refreshMultiSelectTags();
		}
		//this.__selectedItem = null;
		//this.__selectedItems = [];
		if(event)
		{
			event.stopPropagation();
			this.util.dispatchEvent(this.__baseComponent,NSTextBox.ITEM_UNSELECTED,event.detail,{index:event.index});
		}
		else
		{
			this.util.dispatchEvent(this.__baseComponent,NSTextBox.ITEM_UNSELECTED);
		}
	};
	
	NSTextBox.prototype.__multiSelectHandler = function()
	{
		var nsControl = this.__getNSControl();
		if(nsControl && nsControl.getSelectedItems() && nsControl.getSelectedItems().length > 0)
		{
			this.__selectedItems = this.getSelectedItems();
			this.__refreshMultiSelectTags();
			/*var setText = "";
			for(var count = 0;count < this.__selectedItems.length;count++)
			{
				setText += this.__multiSelectionSeparator + this.__selectedItems[count][this.__labelField];
			}
			if(setText && setText.length > 0)
			{
				this.__textBox.value = setText.substring(1,setText.length);
			}*/
		}
	};
	
	NSTextBox.prototype.__refreshMultiSelectTags = function() 
	{
	    var arrTags = this.__getAllMultiSelectTags();
	    var length = arrTags.length;
	    var tag = null;
	    var count = 0;
	    for(count = length - 1;count > -1;count--)
	    {
	    	tag = arrTags[count];
	    	tag.parentNode.removeChild(tag);
	    }
	    var arrSelectedItems = this.getSelectedItems();
	    if(arrSelectedItems && arrSelectedItems.length > 0) 
	    {
	    	length = arrSelectedItems.length;
	    	for(count = 0; count < length; count++) 
	    	{
	    		tag = this.__createMultiSelectTag(arrSelectedItems[count]);
	    		this.__outerContainer.insertBefore(tag,this.__textBox);
	        }
	    }
	    this.__textBox.value = "";
	};
	
	NSTextBox.prototype.__createMultiSelectTag = function(item) 
	{
		var tag = this.util.createDiv(null,"nsTextBoxMultiSelectTag");
	    var content = this.util.createDiv(null,"nsTextBoxMultiSelectTagText");
	    content.textContent = this.__getItemText(item);
	    tag.appendChild(content);
	    var btnRemove = this.util.createDiv(null,"nsTextBoxMultiSelectTagClose");
	    this.util.addEvent(btnRemove,"click",this.__removeMultiSelectTag.bind(this,tag,item));
	    tag.appendChild(btnRemove);
	    return tag;
	};
	
	NSTextBox.prototype.__removeMultiSelectTag = function(tag,item,event) 
	{
		var selectedItems = this.getSelectedItems();
		var index = selectedItems.indexOf(item);
		if(index > -1) 
		{
			item["ns_field_selected"] = false;
			selectedItems.splice(index,1);
			this.setSelectedItems(selectedItems);
		}
		this.__refreshMultiSelectTags();
		this.__isFromCloseIcon = true;
		event = this.util.getEvent(event);
		if(event)
		{
			event.stopImmediatePropagation();
		}
	};
	
	NSTextBox.prototype.__getAllMultiSelectTags = function() 
	{
		return this.__outerContainer.querySelectorAll(".nsTextBoxMultiSelectTag");
	};
	
	NSTextBox.prototype.__getItemText = function(item)
	{
		var retValue = "";
		if(item)
		{
			var isNoRecord = false;
			if(this.__selectedItem["__ns__index"] === -1)
			{
				isNoRecord = true;
			}
			if(!isNoRecord)
			{
				if(this.__textBoxRendererCallback)
				{
					retValue = this.__textBoxRendererCallback(item,this.__labelField);
				}
				else
				{
					retValue = item[this.__labelField];
				}
			}
		}
		return retValue;
	};
	
	NSTextBox.prototype.__isMouseHoverAllowed = function(item)
	{
		if(item && Boolean.parse(item[this.__stopHoveringField]))
		{
			return false;
		}
		return true;
	};
	
	NSTextBox.prototype.__isFocusOnControl = function()
	{
		if(this.hasFocus() || (document.activeElement == this.__textBox) || (this.__getNSControl() && this.__getNSControl().hasFocus()))
		{
			return true;
		}
		return false;
	};
	
	NSTextBox.prototype.__isAutoCompleteTypeList = function()
	{
		return (this.__dropDownType === NSTextBox.DROPDOWN_TYPE_LIST);
	};
	
	NSTextBox.prototype.__getNSControl = function()
	{
		if(this.__isAutoCompleteTypeList())
		{
			return this.__nsList;
		}
		return this.__nsGrid;
	};
	
	NSTextBox.prototype.__measureString = function(control,text)
	{
		if (!text) 
		{
			return 0;
		}
		var self= this;
		var transferStyles = function(fromControl,toControl,arrProperties) 
		{
			var style = "";
			if (arrProperties) 
			{
				var length = arrProperties.length;
				for (var count = 0; count < length; count++) 
				{
					style += arrProperties[count] + ":" + self.util.getStyleValue(fromControl,arrProperties[count]) + ";";
				}
			} 
			else 
			{
				style = fromControl.getAttribute("style");
			}
			toControl.setAttribute("style",style);
		};
		
		var test = this.util.createElement("test",null,"nsTextBoxTest");
		test.appendChild(document.createTextNode(text)); 
		document.body.appendChild(test);
		transferStyles(control,test,['letterSpacing','fontSize','fontFamily','fontWeight','textTransform']);
		var width = test.offsetWidth;
		document.body.removeChild(test);
	
		return width;
	};
	
	NSTextBox.prototype.__getSearchText = function(searchValue)
	{
		if(searchValue && this.__splitSearchType)
		{
			var arrSplit = searchValue.split(this.__splitSearchType);
			if(arrSplit && arrSplit.length)
			{
				searchValue = arrSplit[arrSplit.length - 1]
			}
		}
		return searchValue;
	};
	
	NSTextBox.ITEM_SELECTED = "itemSelected";
	NSTextBox.ITEM_UNSELECTED = "itemUnselected";
	NSTextBox.TYPE_AUTOTEXT = "text";
	NSTextBox.TYPE_AUTOCOMPLETE = "autocomplete";
	NSTextBox.TYPE_EMAIL = "email";
	NSTextBox.TYPE_NUMBER = "number";
	NSTextBox.TYPE_PASSWORD = "password";
	NSTextBox.TYPE_URL = "url";
	NSTextBox.DROPDOWN_TYPE_LIST = "list";
	NSTextBox.DROPDOWN_TYPE_GRID = "grid";
	NSTextBox.LIST_CLOSED_WITHOUT_SELECTION = "listClosedWithoutSelection";
	
	return NSTextBox;
})();
nsModuleExport(this,"NSTextBox",NSTextBox);